<template>
    <div>
        <!--tabs-->
        <nav class="border-bottom position-relative d-flex justify-content-between">
            <v-tabs show-arrows>
                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                <v-tab :class="{ active: selected_index == index }" v-for="(item, index) in inboxes" v-bind:key="index"
                    @click="nodeClicked(item)">
                    <span v-if="index !== 0" v-tooltip="item.fullname" class="inbox_tab_name">
                        {{ item.name }}
                    </span>
                    <span v-if="index === 0" class="inbox_tab_name">{{ item.name }}</span>
                    <span>&nbsp;({{ item.count }})</span>
                </v-tab>
            </v-tabs>
            <div class="d-flex gap-75 align-items-center grid-list-actions">
                <v-menu :left="isLanguageEn" :right="!isLanguageEn" offset-x offset-y :close-on-click="true"
                    :close-on-content-click="false" :value="shown"
                    content-class="sm-full-view filter ml-2rem p-0 py-1 px-1">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="btn-sm" color="white" v-bind="attrs" :ripple="false" v-on="on" @click="shown = true">
                            <img src="/assets/images/icons/filter.svg" alt="" />
                        </v-btn>
                    </template>
                    <div class="pt-4" style="min-width: 232px; max-width: 232px;">
                        <v-btn class="close-btn light-btn float-right sm-screen" icon @click="shown = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <div class="flex-1 overflow-auto px-3">
                            <h3 class="m-0">{{ $t("res_MenuItems_Filter") }}</h3>

                            <div class="pt-5">
                                <div class="mb-4" v-if="hide_filter_category">
                                    <v-label>{{ $t("res_Label_Category") }}</v-label>
                                    <multi-select class="light-bg add-arrow" v-model="filter_category" label="name"
                                        track-by="id" open-direction="bottom" :options="category_items" :searchable="false"
                                        :loading="loading" :internal-search="false" :clear-on-select="false"
                                        :close-on-select="true" :options-limit="300" :max-height="600"
                                        :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect1"
                                        :placeholder="$t('res_Label_Select')">
                                        <template slot="noOptions" slot-scope="props">
                                            {{ $t("res_Msgs_EmptySearch") }}
                                        </template>
                                    </multi-select>
                                </div>
                                <div class="mb-4" v-if="nodeId === 2">
                                    <v-label>{{ $t("res_GridHeaders_ActionType") }}</v-label>
                                    <multi-select class="light-bg add-arrow" v-model="filter_purpose" label="name"
                                        track-by="id" open-direction="bottom" :options="action_types" :searchable="false"
                                        :loading="loading" :internal-search="false" :clear-on-select="false"
                                        :close-on-select="true" :options-limit="300" :max-height="600"
                                        :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect1"
                                        :placeholder="$t('res_Label_Select')">
                                        <template slot="noOptions" slot-scope="props">
                                            {{ $t("res_Msgs_EmptySearch") }}
                                        </template>
                                    </multi-select>
                                </div>
                                <div class="mb-4" v-if="nodeId === 2">
                                    <v-label>{{ $t("res_GridHeaders_Recipient") }}</v-label>
                                    <multi-select class="light-bg add-arrow" v-model="filter_sender" label="name"
                                        track-by="id" open-direction="bottom" :options="sender_items" :searchable="true"
                                        :loading="loading" :internal-search="false" :clear-on-select="false"
                                        :close-on-select="true" :options-limit="300" :max-height="600"
                                        :show-no-results="false" :hide-selected="true" :multiple="false" ref="multiselect2"
                                        @search-change="asyncFindSender" @close="sender_items = []"
                                        :placeholder="$t('res_Label_Select')">
                                        <template slot="option" slot-scope="props">
                                            <div style="height: 50px; width: 100%; display: flex">
                                                <div class="" style="">
                                                    <v-avatar color="#eff2f5" size="43">{{
                                                        CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                                </div>
                                                <div class="ad__box" v-if="props.option.isUser">
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                    </p>
                                                </div>
                                                <div class="ad__box" v-else>
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="noOptions" slot-scope="props">
                                            {{ $t("res_Msgs_EmptySearch") }}
                                        </template>
                                    </multi-select>
                                </div>
                                <div class="mb-4">
                                    <v-label>{{ $t("res_MenuItems_ReferenceNumber") }}</v-label>
                                    <v-text-field solo v-model="filter_reference_number"
                                        :placeholder="$t('res_Label_defaultTextValue')"></v-text-field>
                                </div>
                                <div class="mb-4">
                                    <v-label>{{ $t("res_GridHeaders_Created_ReceivedDate") }}</v-label>
                                    <v-menu offset-y content-class="p-0" v-model="created_date_datePicker"
                                        :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="utils.dateFormat(filter_created_date)" label="" readonly
                                                v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                                :placeholder="constants.defaultDateValue">
                                                <template v-slot:append>
                                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="filter_created_date"
                                            @input="created_date_datePicker = false"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="mb-4">
                                    <v-label>{{ $t("res_GridHeaders_CreatedSubject") }}</v-label>
                                    <v-text-field solo v-model="filter_subject"
                                        :placeholder="$t('res_Label_defaultTextValue')"></v-text-field>
                                </div>
                                <div class="mb-4" v-if="nodeId !== 1">
                                    <v-label>{{ $t("res_GridHeaders_DueDate") }}</v-label>
                                    <v-menu content-class="p-0" offset-y v-model="due_date_datePicker"
                                        :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="utils.dateFormat(filter_due_date)" label="" readonly
                                                v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                                :placeholder="constants.defaultDateValue">
                                                <template v-slot:append>
                                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="filter_due_date"
                                            @input="due_date_datePicker = false"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="mb-4" v-if="nodeId == 2"> 
                                    <v-checkbox :label="$t('res_label_UnOpenedDocument')" v-model="filter_Unopened_Document" solo style="display:flex; align-items:center; "  ></v-checkbox>
                                </div>
                                <div class="mb-4" v-if="nodeId == 2"> 
                                    <v-checkbox :label="$t('res_Label_Overdue')" v-model="filter_Overdue_Document" solo style="display:flex; align-items:center; "  ></v-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="form-actions m-0 mx-4 py-4">
                            <v-btn class="dgs-new-button" @click="clearFilters">{{ $t("res_ButtonText_Clear") }}</v-btn>
                            <v-btn class="dgs-new-button" @click="applyFilters">{{ $t("res_ButtonText_Apply") }}</v-btn>
                        </div>
                    </div>
                </v-menu>
                <v-btn class="btn-sm" color="white" @click="refreshPageGrid()">
                    <img src="/assets/images/icons/refresh.svg" alt="" />
                </v-btn>
                <v-btn class="btn-sm" color="white" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')">
                    <v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon>
                </v-btn>
                <v-btn class="btn-sm" color="white" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')">
                    <v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn v-if="constants.enableManageGridHeaders"  class="btn-sm" color="white" @click="gridHeadersDilaog =true" v-tooltip="'Manage Grid Headers'">
                    <v-icon class="bg-gray custom-button">mdi-cog</v-icon>
                </v-btn>
            </div>
        </nav>

        <div class="tab-content">
            <div class="panel">
                <div class="row m-auto">
                    <div
                        :class="{ 'custom-col col-lg-7 col-xl-6 p-0 side-padding': openPreviewPane, 'col-md-12 p-0 mb-2': !openPreviewPane }">
                        <v-layout column>
                            <v-flex class="position-relative sm-margin mt-2 DocumentsList" md12>
                                <div  class="d-flex justify-content-end gap-75 align-items-center bottom-action-bar bottom-fixed shadow-sm" style="margin:0px !important;border:1px solid #e7ebef;padding-right:100px;padding-left:100px" 
                                v-if="selected.length !== 0 && !enableSingleSelect && !openPreviewPane"  v-for="(item, index) in selected" :key="index">
                                    <div class="d-flex gap-75">
                                        <v-btn class="light-blue" v-if="shouldShowButton('Archive')" @click="openCompleteDocumentDialog()">
                                            {{ $t("res_ButtonText_Archive") }}
                                        </v-btn>
                                    <!--    <v-btn class="light-blue" v-if="shouldShowButton('Complete')" @click="completeTransfers()">
                                            {{ $t("res_ButtonText_Complete") }}
                                        </v-btn>-->
                                           <v-btn class="light-blue" v-if="shouldShowButton('Sign')" v-tooltip="$t('res_ButtonText_Sign')" @click="signDocument()">
                                            {{ $t("res_ButtonText_Sign") }}
                                        </v-btn>
                                        <v-btn class="light-blue" v-if="shouldShowButton('SignAndSend')" v-tooltip="$t('res_ButtonText_SignAndSend')" @click="OpenTransferForm('Sign')">
                                            {{ $t("res_ButtonText_SignAndSend") }}
                                        </v-btn>
                                        <v-btn class="light-blue" v-if="shouldShowButton('Forward')" @click="OpenTransferForm('Forward')">
                                            {{ $t("res_MenuItems_Forward") }}
                                        </v-btn>
                                        <v-btn class="light-blue" v-if="shouldShowButton('SendCC')" @click="OpenTransferForm('SendCC')">
                                            {{ $t("res_MenuItems_SendCC") }}
                                        </v-btn>
                                      <!--  <v-btn class="light-blue" v-if="shouldShowButton('DismissCced')" @click="DismissCcedBulkTransfer()">
                                            {{ $t("res_Label_CcedDismiss") }}
                                        </v-btn> -->
                                        <v-btn class="light-blue" @click="printCorrespondences(false)">
                                            {{ $t("res_ButtonText_Download") }}
                                        </v-btn> 
                                      <v-btn class="light-blue" @click="printCorrespondences(true)">
                                            {{ $t("res_ButtonText_PrintWithAttachments") }}
                                        </v-btn>
                                      <!--  <v-btn v-if="nodeId == 1" class="light-blue" @click="deleteDrafts()">
                                            {{ $t("res_ButtonText_Delete") }}
                                        </v-btn>-->
                                    </div>
                                </div> 
                                <!--table-->
                                <!-- remove single-select in sprint 2 -->
                                <v-data-table 
                                id="ListCorrespondancesTable"
                                :show-expand="shouldShowExpand()" :expanded.sync="expanded" 
                                single-expand
                                expand-icon="mdi-menu-down"
                                :mobile-breakpoint="0" 
                                :headers="grid_headers" v-model="selected"
                                              :items="correspondences"   :item-key="nodeId == 1 ? 'id' : 'transferId'"
                                               :items-per-page="pagingData.pageSize"
                                               hide-default-footer class="elevation-1 empty-full-height" 
                                               :show-select="nodeId == 1 || nodeId == 2? true : false"
                                               :single-select="enableSingleSelect"
                                              :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :item-class="getRowClass"
                                              @dblclick:row="openFullView" @click:row="previewCorrespondence" 
                                              @item-selected="itemSelected" @update:sort-by="updateSortBy"  
                                              @update:sort-desc="updateSortDesc" must-sort>
                                              
                                    <template v-slot:expanded-item="{ item }">
                                        <td colspan="100%" style="padding-left: 0px !important; padding-right: 0px !important;">
                                            <div class="expanded-item-container">
                                                <v-data-table
                                                    class="expanded-item-table"
                                                    :headers="filteredHeaders"
                                                    :items="getDynamicList(item)"
                                                    :item-class="getRowClass"
                                                    hide-default-footer
                                                    @click:row="previewCorrespondence">
                                                    <template v-slot:item.sentTo="{ item }">
                                                        {{ item.sentTo ?? item.recipient }}
                                                    </template>
                                                </v-data-table>
                                            </div>
                                        </td>                                 
                                    </template>
                                    <template v-slot:[`item.toUserId`]="{ item }">
                                        <label class="float-end mx-2" v-if="item.toUserId == null">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" color="#f77600">mdi-bookmark</v-icon>
                                                </template>
                                                <span class="p-3" style="color: #f77600;">{{ $t("res_Label_SentToStructure") }}</span>
                                            </v-tooltip>
                                        </label>
                                    </template>
                                    <!--overdue-->
                                    <template v-slot:item.overdue="{ item }">
                                        <label class="float-end text-warning mx-2">
                                            <v-icon>{{ utils.getOverDue(item.overdue, nodeId) }}</v-icon> 
                                            {{ utils.getOverdueDays(item.overdue, item.overdueDays, nodeId) }}
                                        </label>
                                    </template>
                                    <template v-slot:item.categoryId="{ item }">
                                        {{ getCategoryTitle(item.categoryId) }}
                                    </template>
                                    <!--status-->
                                    <template v-slot:item.status="{ item }">
                                        <v-chip dark v-bind:class=getStatusClass(item)>{{ item.status }}</v-chip>
                                    </template>
                                    <template v-slot:item.purpose="{ item }">
                                        <v-chip dark v-bind:color=getPurposeColor(item)>{{ item.purpose }}</v-chip>
                                    </template>
                                    <!--follow up-->
                                    <template v-slot:item.flag="{ item }">
                                        <v-icon @click="item.flag = !item.flag"> {{ getFollowUp(item.flag) }} </v-icon>
                                    </template>
                                    <!--attachment-->
                                    <template v-slot:item.hasAttachment="{ item }">
                                        <v-icon>{{ getAttachment(item.hasAttachment) }}</v-icon>
                                    </template>
                                    <template v-slot:item.subject="{ item }">
                                        <a :id="'ellipsisElements_1_' + item.id" class="td-text-limit"
                                           @click="previewCorrespondence(item)">
                                            <span class="subjectCell">{{ item.subject }}</span>
                                        </a>
                                        <a :id="'ellipsisElements_2_' + item.id" class="td-text-limit" style="display:none;"
                                           v-tooltip="item.subject" @click="previewCorrespondence(item)">
                                            <span>{{ item.subject }}</span>
                                        </a>
                                    </template>
                                    <template v-slot:item.sender="{ item }">
                                        <span class="text-limit" v-tooltip="item.sender">{{ item.sender }}</span>
                                    </template>
                                    <template v-slot:item.recievedDate="{ item }">
                                        {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.recievedDate) : utils.formatDateTime(item.recievedDate)  }}
                                    </template>
                                    <template v-slot:item.createdDate="{ item }">
                                        {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.createdDate) : utils.formatDateTime(item.createdDate)  }}                                       
                                    </template>
                                    <template v-slot:item.dueDate="{ item }">
                                        {{ utils.formatDateTime(item.dueDate) }}
                                    </template>
                                    <template  v-slot:item.projectNumber="{ item }">
                                        <span class="text-limit" v-tooltip="item.projectNumber">{{ item.projectNumber }}</span>
                                    </template>
                                    <template  v-slot:item.contractNumber="{ item }">
                                        <span class="text-limit" v-tooltip="item.contractNumber">{{ item.contractNumber }}</span>
                                    </template>
                                    <template  v-slot:item.contractName="{ item }">
                                        <span class="text-limit" v-tooltip="item.contractName">{{ item.contractName }}</span>
                                    </template>
                                    <template v-slot:no-data>
                                        <div class="flex-1">
                                            <img src="/assets/images/empty-inbox.svg" alt="" />
                                            <p class="m-0">
                                                {{ $t("res_Msgs_GetAllCaughtUp") }}
                                                <br>
                                                {{ $t("res_Msgs_NoNewItem") }}
                                            </p>
                                        </div>
                                    </template>
                                </v-data-table>
                                <div class="d-flex align-items-center mt-2">
                                    <Pagination :totalCount="inboxes[selected_index].count" :pageSize="pagingData.pageSize"
                                                :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"
                                                :showPageSize="false" :showMargin="false"></Pagination>
                                    <!-- 
                                        <v-btn v-if="inboxes[0].count > 0" class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')"><v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon></v-btn>
                                        <v-btn v-if="inboxes[0].count > 0" class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')"><v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon></v-btn> 
                                    -->
                                </div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <div :class="{ 'custom-col col-lg-5 col-xl-6 p-0 py-2': openPreviewPane }" v-if="openPreviewPane">
                        <div
                            style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden;height:95%">
                            <div>
                                <v-btn class="close-btn d-block bg-white close-viewer " icon @click="closePreview()">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>

                            <!--viewer section-->
                            <div class=" position-relative viewer-container scrollable-container"
                                style="height: calc(100vh - 176px - 1rem); overflow-y: hidden;">
                                <div v-if="empty_viewer" class="empty-viewer"
                                    style="border-radius: 12px; height: calc(100vh - 176px);">
                                    <img src="/assets/images/icons/template.svg" />
                                    <img src="/assets/images/icons/no_preview.svg" />
                                    <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                                </div>
                                <div v-if="!empty_viewer" id="viewer_template" class="h-100" style="border-radius: 12px;">
                                    <iframe id="viewerFrame" :src="viewerFrame" class="w-100" style="height:100%"></iframe>
                                </div>
                            </div>
 
                            <!--action buttons-->
                            <div class="d-flex justify-content-between align-items-center bottom-action-bar m-0 gap-2 w-100" id="rowContainer">
 
                                <TransferNotesIcon ref="transferNotesIcon" :isSecretNote="isSecretNote" :toUserId="toUserId" :loginUserId="loginUserId"></TransferNotesIcon>

                                <div class="d-flex gap-2 ml-auto">
                                    <v-btn color="light-blue" @click="openFullView" id="btn_fullView">{{ $t("res_ButtonText_Full_View")}}</v-btn>


                                    <div v-if="!utils.hasActiveWorkflow(selectedItem.item)" v-for="(item, index) in toolbarButtons" v-bind:key="index">
                                        <v-btn :class="item.btnClass" @click="item.btnClick" max-width="149">
                                            {{ $t(`${item.btnText}`) }}
                                            <v-icon v-if="item.btnIcon" class="custom-icon">{{ item.btnIcon }}</v-icon>
                                        </v-btn>
                                    </div>

                                </div>

                                <v-menu v-if="!utils.hasActiveWorkflow(selectedItem.item)" content-class="viewer-button align-bottom-left" top :offset-y="offset"
                                    :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" class="light-blue more-btn">
                                            <span>{{ $t("res_MenuItems_MoreActions") }}</span>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <div v-for="(item, index) in moreActionButtons" v-bind:key="index">
                                            <v-list-item @click="item.btnClick">{{ $t(`${item.btnText}`) }}</v-list-item>
                                        </div>

                                        <v-list-item @click="dispatchCorrespondence()" v-if="utils.ActionsPermission('DispatchCorrespondence', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_DialogTitle_DispatchCorrespondence") }}</v-list-item>
                                        <v-list-item @click="openVisualTracking(true)" v-if="utils.ActionsPermission('VisualTracking', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_VisualTracking") }}</v-list-item>
                                        <v-list-item @click="hideCorrespondenceDialog = true" v-if="utils.ActionsPermission('HideCorrespondence', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{ $t("res_Label_Hide") }}</v-list-item>
                                        <v-list-item @click="cancelFollowup()" v-if="utils.ActionsPermission('CancelFollowup', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{ $t("res_ButtonText_CancelFollow_Up") }}</v-list-item>
                                        <v-list-item @click="openSigningHistory(true)" v-if="utils.ActionsPermission('SigningHistory', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_DialogTitle_SigningHistory") }}</v-list-item>
                                        <v-list-item @click="openDeliveryNote()" v-if="utils.ActionsPermission('GenerateDeliveryNote', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{ $t("res_Label_GenerateDeliveryNote") }}</v-list-item>
                                        <v-list-item @click="CreateOutgoing()" v-if="utils.ActionsPermission('CreateOutgoing', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_Outgoing") }}</v-list-item> 
                                        <v-list-item @click="reminderEmailDialog = true" v-if="utils.ActionsPermission('EmailReminder', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_Reminder") }}</v-list-item>
                                        <v-list-item @click="resetDocument()" v-if="utils.ActionsPermission('ResetDocument', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId , this.nodeId)">{{ $t("res_Tooltip_ResetDocument") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Send Back')" v-if="utils.ActionsPermission('SendBack', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_MenuItems_SendBack") }}</v-list-item>
                                        <v-list-item @click="complete()"  v-if="utils.ActionsPermission('SendBack', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_Label_Complete") }}</v-list-item>

                                        <v-list-item @click="printCorrespondence(false)">{{ $t("res_ButtonText_Download") }}</v-list-item>
                                        <v-list-item @click="printCorrespondence(true)">{{ $t("res_ButtonText_PrintWithAttachments") }}</v-list-item>
                                        <v-list-item @click="notifyEmailCorrespondence(true,true)" v-if="utils.ActionsPermission('TaskReminder', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId) && this.selectedItem.item.categoryId==6">{{ $t("res_ButtonText_RemindOnTask") }}</v-list-item>
                                        <v-menu content-class="viewer-button align-bottom-left2" :left="isLanguageEn" :right="!isLanguageEn" top offset-x offset-y>
                                            <template v-slot:activator="{ on, attrs }" v-if="nodeId != 1">
                                                <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">{{
                                                    $t("res_MenuItems_SendBy") }}
                                                    <v-icon>mdi-chevron-down</v-icon>
                                                </v-list-item>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="sendCorrespondence(false)">{{ $t("res_MenuItems_Email")
                                                }}</v-list-item>
                                                <v-list-item @click="sendCorrespondence(true)">{{
                                                    $t("res_MenuItems_EmailWithAttachments") }}</v-list-item>
                                            </v-list>
                                        </v-menu>
                                        <!-- ['', '', '', '', '', '', '', 'EmailReminder'] -->

                                        <!-- <v-list-item @click="signDocument()" v-if="utils.ActionsPermission('Sign', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId, this.canSignDocument)">{{ $t("res_ButtonText_Sign") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Rejected')" v-if="utils.ActionsPermission('Reject', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId, this.canSignDocument)">{{ $t("res_ButtonText_Reject") }}</v-list-item>
                                        <v-list-item @click="OpenTransferForm('Endorse')" v-if="utils.ActionsPermission('Endorse', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_MenuItems_Endorse") }}</v-list-item>
                                        <v-list-item @click="openCompleteDocumentDialog()" v-if="utils.ActionsPermission('Archive', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_Archive") }}</v-list-item>
                                        
                                        <v-list-item @click="returnToInbox()" v-if="utils.ActionsPermission('ReturnToInbox', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_ReturnToInbox") }}</v-list-item>

                                        <v-list-item @click="Dismiss()" v-if="utils.ActionsPermission('Dismiss', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_ButtonText_isDismiss") }}</v-list-item>
                                        <v-list-item @click="DismissCced()" v-if="utils.ActionsPermission('DismissCced', this.selectedItem.item, this.selectedItem.item.transferId, this.selected_node.delegationId, this.nodeId)">{{ $t("res_Label_CcedDismiss")}}</v-list-item> -->
                                        
                                    </v-list>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="correspondenceDialog" :key="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog"
            fullscreen v-bind:persistent="nodeId == 1">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView :documentId="documentId" :transferId="transferId" :viewMode="viewMode"
                :delegationId="delegationId" :toEmail="toEmail" :emailCC="emailCC"
                :closeDialogEvent="closeCorrespondenceDialog" :createReplyDocumentEvent="CreateReplyDocument" :openedFromNodeId="nodeId" :nodeDelegationId="nodeDelegationId"/>
        </v-dialog>
        <v-dialog v-model="gridHeadersDilaog" max-width="600" class="bg-primary" scrollable>
            <v-card>
              <v-toolbar class="bg-white">
                <v-card-title class="p-0">
                  <span>{{ $t("res_Title_ManageGridHeaders") }}</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-btn class="close-btn light-btn" icon dark @click="gridHeadersDilaog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-container>
                <v-row>
                  <v-col>
                    <Container :get-child-payload="getChildPayload2" class="list-box" style="min-height: 300px; margin-bottom: 5px">
                      <Draggable v-for="(item, index) in selectedItemGridWithOutTranslation"  :key="item.id" >
                        <v-row align="center"  @mousedown="getChildPayload2({ index, item })">
                          <v-col cols="3">
                            <v-label  >{{ $t(item.text) }}</v-label>
                          </v-col>
                          <v-col cols="4">
                            <label>{{ $t("res_Label_Width") }}</label>
                            <v-text-field v-model="item.width" solo></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox :label="$t('res_CheckBoxTitle_Show')" v-model="item.show" solo></v-checkbox>
                          </v-col>
                        </v-row>
                      </Draggable>
                    </Container>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="justify-end" style="position: sticky; bottom: 0; background-color: white;">
                <v-btn class="light-blue" @click="gridHeadersDilaog = false" style="min-width: 100px !important;">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn class="primary" style="min-width: 100px !important;" @click="saveGrid()">{{ $t("res_ButtonText_Continue") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
 
        <v-dialog v-model="transferFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ transferFormHeader }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="closeTransferFormDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <TransferForm :documentId="documentId" :disableAdvancedTransfer="disableAdvancedTransfer" :disableRecipient="recipientDisabled" :purpose="purpose"
                    :sign="signForm" :transferId="transferId" :transferCC="transferCC" :transferTo="(userDefaultTransferTo == null ? transferTo : userDefaultTransferTo)"
                    :transferToMulti="transferToMulti" :rejected="rejected" :successMessage="transferSuccessMessage"
                    :forwardCC="forwardCC"
                    :delegationId="delegationId"
                    :hideTransferCC="hideTransferCC" :readOnlyPurpose="readOnlyPurpose"
                    :checkForAttachmentsUploadMultiApproval="checkForAttachmentsUploadMultiApproval"
                    :transferFormDialog="transferFormDialog" @closeTransformDialog="closeTransferFormDialog"
                    @cancelCorrespondenceDocument="transferFormDialog = false"  :documentCreatedByUserId="this.selectedItem.item.createdByUserId" :categoryId="this.selectedItem.item.categoryId"
                                  :mom_purpose_items="mom_purpose_items" />
            </v-card>
        </v-dialog>

        <v-dialog v-model="deliveryNoteDialog" content-class="small-dialog" width="650" height="1350">
            <v-card>
                <v-card-title>{{ $t('res_Label_DeliveryNote') }}</v-card-title>
                <div style="overflow: hidden">
                    <DeliveryNoteConfiguration :documentId="documentId" :referenceNumber="referenceNumber"
                        :deliveryNoteDialog="deliveryNoteDialog" @closeDeliveryNote="deliveryNoteDialog = false" />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="signingHistoryDialog"
            content-class="dialog with-fixed-actions bg-white  justify-content-center w-50" fullscreen scrollable>
            <v-card class="bg-white">
                <v-toolbar class="bg-white">
                    <v-card-title style="line-height: 28px">
                        {{ $t("res_DialogTitle_SigningHistory") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="signingHistoryDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="border-top p-0 d-flex">
                    <SigningHistory :documentId="selectedDocumentId"></SigningHistory>
                </v-card-text>
                <v-card-actions class="d-flex justify-content-end" style="background-color:  #E7EBEF;">
                    <v-btn class="dgs-new-button-inner" style="height: 48px" @click="openVisualTracking()">
                        <img class="rtl-flip" width="26px" src="/assets/images/icons/tracking.svg" />{{
                            $t("res_ButtonText_Tracking") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="visualTrackingDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
            width="100%" fullscreen>
            <div class="dialog-header">
                <!-- <v-icon class="back-btn">mdi-chevron-left</v-icon> -->
                <v-btn class="close-btn light-btn tracker-close" icon dark @click="visualTrackingDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-body h-100">
                <iframe id="trackingFrame" :src="trackingFrameSrc"
                    style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
            </div>
        </v-dialog>

        <v-dialog v-model="notifyEmailDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{this.isMOM ? $t("res_ButtonText_RemindOnTask"): $t("res_MenuItems_Notify")  }}  
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="notifyEmailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <notify-email v-on:closeDialog="notifyEmailDialog = false" :toEmail="toEmail" :emailCC="emailCC"
                       :subject="notifySubject"  :documentId="this.selectedItem.item.documentId" :transferId="this.selectedItem.item.transferId" :isMOM ="this.isMOM "></notify-email>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dispatchFormDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen
            width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_DialogHeaders_DispatchLetter") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="dispatchFormDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <DispatchLetter :documentId="selectedDocumentId" :dialogModelShow="dispatchFormDialog"
                    :withAttachments="withAttachments" v-on:closeDialog="dispatchFormDialog = false" :transferId="transferId">
                </DispatchLetter>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dispatchCorrespondenceFormDialog" width="500" height="400">
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_DialogTitle_DispatchCorrespondence") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="dispatchCorrespondenceFormDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <DispatchCorrespondence :documentId="selectedDocumentId" :dialogModelShow="dispatchCorrespondenceFormDialog"
                    v-on:closeDialog="dispatchCorrespondenceFormDialog = false"></DispatchCorrespondence>
            </v-card>
        </v-dialog>

        <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
            <v-card>
                <v-card-title class="text-h5 blue lighten-2">
                    {{ $t("res_CardHeaders_Sign") }}
                </v-card-title>
                <div style="overflow: hidden">
                    <Sign :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                        @refreshAfterClosingSignDialog="refreshAfterClosingSignDialog"
                        @closeSignFormDialog="closeSignFormDialog" />
                </div>
            </v-card>
        </v-dialog>

<v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                                              @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                                              @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                                              @closeSignFormDialog="closeSignFormDialog" :hasBeenSignedWithUAEPass="selectedItem.item.hasBeenSignedWithUAEPass"
                                              :isUAEPassEnabledForTemplate="selectedItem.item.isUAEPassEnabled"
                                              :isEsealEnabledForTemplate="selectedItem.item.isEsealEnabled"
                                              @refreshAfterClosingSignMethodSelect="refreshAfterClosingSignMethodSelect" />
                    </div>
                </v-card>
        </v-dialog>
        <v-dialog v-model="completeDocumentDialog" content-class="small-dialog" width="500" height="350">
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_CompleteNotes") }}
                </v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Msgs_EnterNotes") }} *</label>
                    <v-textarea v-model="completeDocument_noteText" solo></v-textarea>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" width="100"
                        @click="completeDocument_noteText = ''; completeDocumentDialog = false;">{{
                            $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" width="100" @click="completeDocument()">{{ $t("res_ButtonText_Continue")
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="hideCorrespondenceDialog" content-class="small-dialog" width="400px">
            <v-card>
                <v-card-title>
                    {{ $t("res_Label_Hide") }}
                </v-card-title>
                <div class="card-body">
                    <div class="col-sm-12">
                        <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                        <v-menu content-class="p-0" v-model="hideToDateMenu" :close-on-content-click="false"
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="hideToDate" label="" readonly v-bind="attrs" v-on="on" solo
                                    append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="hideToDate" @input="hideToDateMenu = false"
                                :min="nowDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="hideCorrespondenceDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn color="primary" @click="SaveForLater">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="reminderEmailDialog" content-class="small-dialog" width="400px">
            <v-card>
                <v-card-title class="p-0">
                    {{ $t("res_ButtonText_Reminder") }}
                </v-card-title>
                <div class="card-body">
                    <div class="col-sm-12">
                        <label class="label_required">{{ $t("res_Label_ToDate") }} *</label>
                        <v-menu content-class="p-0" v-model="remindToDateMenu" :close-on-content-click="false"
                            :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="reminderToDate" label="" readonly v-bind="attrs" v-on="on" solo
                                    append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="reminderToDate" @input="remindToDateMenu = false"
                                :min="nowDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="reminderEmailDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" @click="ReminderByEmail()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

	    <v-dialog fullscreen content-class="fullscreen-dialog" v-model="visualTrackingDialogNew">  
		<TrackingView2 :documentId="visualTrackingDialogNew_selectedDocumentId" :closeDialogFunc="closeNewTrackerDialog" />  
		</v-dialog>
		

    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import Tabs from './Tabs.vue'
import MultiSelect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import CreateDocumentView from '@/views/CreateDocumentView.vue'
import { defaultGet, defaultPost } from '@/assets/js/common.js'
import TransferForm from '@/components/TransferForm.vue'
import SigningHistory from '@/components/SigningHistory.vue'
import TrackingTree from '@/components/TrackingTree.vue'
import * as utils from '@/assets/js/common.js'
import NotifyEmail from '@/components/NotifyEmail.vue'
import DispatchLetter from '@/components/DispatchLetter.vue'
import DispatchCorrespondence from '@/components/DispatchCorrespondence.vue'
import DeliveryNoteConfiguration from './DeliveryNoteConfiguration.vue'
import Sign from '@/components/Sign.vue'
import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
import Pagination from '@/components/Pagination.vue'
import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
import MessagesUtil from '@/utils/messagesUtil' 
import TrackingView2 from "@/views/TrackingView2.vue";
import { Container, Draggable } from 'vue-smooth-dnd'

export default {
    name: 'ListCorrespondences',
    components: { TrackingView2, Tabs, MultiSelect, CreateDocumentView, TransferForm, SigningHistory, TrackingTree, NotifyEmail, DispatchLetter, DeliveryNoteConfiguration, Sign, Pagination, TransferNotesIcon, DispatchCorrespondence,SignSelectSignMethod },
    props:
    {
        nodeId: { type: Number, default: 0 }
       // purposeFilter: { type: String, default: ''}
    },
    data() {
        return {
            expanded: [],
            expandedRows: [],
            expandedRow: null,
            hideTransferCC:false,
            readOnlyPurpose:false,
            visualTrackingDialogNew: false,
            visualTrackingDialogNew_selectedDocumentId: 0,
            rejected: false,
            forwardCC: false,
            transferSuccessMessage: '',
            propertyBag: {},
            signFormDialog: false,
            selectSignMethodFormDialog: false,
            recipientDisabled: false,
            isLanguageEn: true,
            shown: false,
            offset: true,
            loading: false,
            sender_items: [],
            action_types: [],
            category_items: [],
            hide_filter_category: false,
            filter_category: '',
            filter_reference_number: '',
            filter_created_date: '',
            filter_subject: '',
            filter_due_date: '',
            filter_sender: null,
            filter_purpose: null,
            filter_Unopened_Document: false,
            filter_Overdue_Document: false,
            due_date_datePicker: false,
            created_date_datePicker: false,
            display_alert: false,
            messagesUtil: MessagesUtil,
            isExport: false,
            exportType: 0,
            /*sort by pinned*/
            sortBy: 'id',
            sortDesc: true,

            selected_node_id: 0,
            correspondences: [],
            nonGroupedCorrespondences: [],
            selectedItem: {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false},
            selected: [],
           
            grid_headers: [
                { text: '', value: 'data-table-select', width:'10px' },
                { text: 'Subject', value: 'subject', sortable: false ,show:false },
                { text: '', value: 'Overdue', sortable: false ,show:false },
                { text: 'Due date', value: 'dueDate', sortable: true ,show:false },
                { text: 'Forwarded from', value: 'fromUser', sortable: false ,show:false },
                { text: 'Sender', value: 'sender', sortable: false ,show:false },
                { text: 'Privacy', value: 'privacy', sortable: false,show:false },
                { text: 'Action types', value: 'purpose', sortable: false,show:false },
                { text: 'Status', value: 'status', sortable: false ,show:false},
                { text: 'Received on', value: 'received_on', sortable: true ,show:false},
                { text: '', value: 'flag', sortable: false,show:false },
                { text: '', value: 'attachment', sortable: false ,show:false}
            ],
            selectedItemGrid: [],
            selectedItemGridWithOutTranslation: [],
            openPreviewPane: false,
            clickedItem: {},
            viewerFrame: '',
            empty_viewer: true,

            inboxes: [{ id: 1, name: 'My Inbox', inboxId: 1, delegationId: 0, count: 0 }],
            selected_node: {},
            selected_index: 0,
            delegationId: 0,
            nodeDelegationId: 0,

            correspondenceDialog: false,
            documentId: 0,
            transferId: 0,
            viewMode: 'readonly',
            userDefaultTransferTo: null,
            transferCC: [],
            transferTo: null,
            transferToMulti: [],
            transferFormHeader: 'Transfer',
            transferFormDialog: false,
            purpose: {},
            signForm: false,
            checkForAttachmentsUploadMultiApproval: false,
            disableAdvancedTransfer:true,

            selectedDocumentId: 0,
            trackingFrameSrc: '',
            signingHistoryDialog: false,
            visualTrackingDialog: false,
            notifyEmailDialog: false,
            dispatchFormDialog: false,
            reminderEmailDialog: false,
            dispatchCorrespondenceFormDialog: false,

            withAttachments: false,
			isMOM: false,			 

            referenceNumber: "",
            deliveryNoteDialog: false,

            toEmail: "",
            emailCC: "",
            notifySubject: "",
            utils: utils,
            constants: constants,
            pagingData: {
                pageSize: 20,
                pageIndex: 0
            },
            completeDocumentDialog: false,
            completeDocument_noteText: '',
            canSignDocument: false,
            showActionsBtns: false,
            hideCorrespondenceDialog: false,
            hideToDate: '',
            hideToDateMenu: false,
            reminderToDate: '',
            remindToDateMenu: false,
            nowDate: new Date().toISOString().slice(0, 10),
            fromEmail: [],
            toolbarButtons: [],
            moreActionButtons: [],
            isSecretNote: false,
            toUserId:0,
            loginUserId:0,
            gridHeadersDilaog: false,
            mom_purpose_items:[],
            canBeSignedByExternalUser: false,
            expanded_headers: [
                { text: this.$t('res_GridHeaders_ActionType'), value: 'purpose', sortable: false },
                { text: this.$t('res_GridHeaders_DueDate'), value: 'dueDate', sortable: false },
                { text: this.$t('res_GridHeaders_FromUser'), value: 'senderUser', sortable: false },
                { text: this.$t('res_GridHeaders_FromStructure'), value: 'sender', sortable: false },           
                { text: this.$t('res_Label_Status'), value: 'status', sortable: false },
                { text: this.$t('res_GridHeaders_Recieved'), value: 'recievedDate', sortable: false }
            ],
                expanded_headers_sent: [
                { text: this.$t('res_GridHeaders_ActionType'), value: 'purpose', sortable: false },
                { text: this.$t('res_GridHeaders_DueDate'), value: 'dueDate', sortable: false },           
                { text: this.$t('res_GridHeaders_ToUser'), value: 'sentTo', sortable: false },
                { text: this.$t('res_GridHeaders_ToStructure'), value: 'recipient', sortable: false },
                { text: this.$t('res_Label_Status'), value: 'status', sortable: false },
                { text: this.$t('res_GridHeaders_Recieved'), value: 'recievedDate', sortable: false }
            ],
            //expandedRows: {}
        };
    },
    mounted() {
        
        //to-remove  
        const selectedLang =  localStorage.getItem('lang');
            if(sessionStorage.getItem('user') != '' && sessionStorage.getItem('user') != null)
        {  
            const userId = JSON.parse(sessionStorage.getItem('user')).profile.Id;
            const userItem = window.usersSelectedStructureForTransfer.length == 0 ? null : window.usersSelectedStructureForTransfer.find(s=>s.userId == userId);
            if(userItem != null) 
            { 
            this.userDefaultTransferTo = {'id': userItem.id , 'name' : (selectedLang == 'ar' ? userItem.nameAr : userItem.nameEn)};
            }
            else
            {
                this.userDefaultTransferTo = null;
            }
        } 
        this.transferFormHeader = window.translate("res_DialogTitle_Transfer")
        this.inboxes = [{ id: 1, name: window.translate("res_TabsName_Inbox"), inboxId: 1, delegationId: 0, count: 0 }]
        this.grid_headers = [
            { text: '', value: 'data-table-select', width:'10px' },
            { text: window.translate("res_GridHeaders_CreatedSubject"), value: 'subject', sortable: false },
            { text: window.translate("res_Label_Overdue"), value: 'overdue', sortable: false },
            { text: window.translate("res_GridHeaders_DueDate"), value: 'dueDate', sortable: true },
            { text: window.translate("res_GridHeaders_ForwaredFrom"), value: 'fromUser', sortable: false },
            { text: window.translate("res_Label_Sender"), value: 'sender', sortable: false },
            { text: window.translate("res_Label_Privacy"), value: 'privacy', sortable: false },
            { text: window.translate("res_GridHeaders_ActionType"), value: 'purpose', sortable: false },
            { text: window.translate("res_Label_Status"), value: 'status', sortable: false },
            { text: window.translate("res_Label_RecievedOn"), value: 'received_on', sortable: true },
            { text: '', value: 'flag', sortable: false },
            { text: '', value: 'attachment', sortable: false }
        ]

        setTimeout(function () {
            var headers = document.querySelectorAll('.v-data-table-header th.sortable');
            headers.forEach(function (header) {
                var span = header.querySelector('span');
                var icon = header.querySelector('.v-data-table-header__icon');
                span.append(icon);
            });
        }, 10)
        var user = JSON.parse(sessionStorage.getItem("user"));
        this.fromEmail = user.profile.Email;
        this.loginUserId = user.profile.Id;

        if (!utils.CheckIfNullOrEmpty(sessionStorage.getItem("transferId"))) {
                this.transferId = sessionStorage.getItem("transferId");
                sessionStorage.removeItem("transferId");
        }    
        //console.log('changed2 '+this.$route.query.purposeFilter);
        // this.$nextTick(() => {
        //     this.filterByPurpose(this.$route.query?.purposeFilter);
        // });
    },
    methods:
    {  
           
        shouldShowButton(action) 
        {
            
            //console.log('selected = ',this.selected)
            var showValue = true		   
			 
            for (var i = 0; i < this.selected.length; i++) 
            {
                var item = this.selected[i]
                if (item != null && item != undefined) 
                {
                    var value1 = utils.ActionsPermission(action, item, item.transferId, this.delegationId, this.nodeId, item.canSign)
                    showValue = showValue && value1
									  
                }
            }

													  
            return showValue
        },	   
		
        toggleRow(id) {
            if (this.expandedRows.includes(id)) {
                this.expandedRows = this.expandedRows.filter((rowId) => rowId !== id);
            } else {
                this.expandedRows.push(id);
            }
        },
        getDynamicList(correspondence) {
            const items = this.nonGroupedCorrespondences
            .filter((elem) => elem.documentId === correspondence.documentId);
            return items ? items : [];
        },
        createUniqueList(correspondencesList) {
            const uniqueList = [];
            const seen = new Set();
            
            for (const item of correspondencesList) {
                // Normalize the key, treating null as a unique string
                 const uniqueKey = `${item.documentId}`;
                 // const uniqueKey = `${item.documentId}-${item.transferId ?? "null"}`;
                  
                if (!seen.has(uniqueKey)) {
                seen.add(uniqueKey);
                uniqueList.push(item);
                }
            }

            //console.log("Unique List:", uniqueList);
            return uniqueList; // Optional if you need the list later
        },
        toggleDropdown(rowId) {
            //console.log("clicked");
            //const copiedList = [...this.correspondences];
            //copiedList.pop();
            //this.correspondences = copiedList;
            //console.log(this.correspondences);
            this.expandedRow = this.expandedRow === rowId ? null : rowId;
            //[this.correspondences[0], this.correspondences[this.correspondences.length - 1]] = [this.correspondences[this.correspondences.length - 1], this.correspondences[0]];

        }
        ,
        complete()
        {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + this.selectedItem.item.documentId + '&transferId=' + this.selectedItem.item.transferId)
                .then(res => 
                {
                    if (res.data == 1) 
                    {
                        window.showInformation('Confirmation', window.translate("res_Msgs_TransferCompleteConfirmation"),
                            () => 
                            {
                                window.showLoading()
                                axios.get(constants.baseApiUrl + 'Transfer/DismissCcedTransfer?transferId=' + this.selectedItem.item.transferId)
                                    .then(res => 
                                    {
                                        if (res.data != null && res.data > 0) 
                                        {
                                            window.showAlert('res_Msgs_TransferCompleted', 'success')
                                        }
                                    })
                                    .catch(error => console.log(error))
                                    .finally(() => window.hideLoading())
                            });
                    }
                    else
                    {
                        window.hideLoading()
                        window.showAlert('res_Msgs_TransferNotCompleted', 'warning')
                    }
                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading())
        },
        onDropAction(collection, dropResult) {
              this.grid_headers = applyDrag(collection, dropResult)
            },
		applyDrag(arr, dragResult) {
            const { removedIndex, addedIndex, payload } = dragResult;
            if (removedIndex === null && addedIndex === null) return arr;

            const result = [...arr];
            let itemToAdd = payload;

            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }

            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }

            result.forEach((item, index) => {
                item.index = index;
            });

            return result;
            },
		getChildPayload2(index) {
              return this.grid_headers[index];
            },
        saveGrid() { 
            let gridData = new FormData();
            gridData.append('gridData',JSON.stringify(this.selectedItemGridWithOutTranslation))//.selectedItemGridWithOutTranslation
                 
            window.showLoading();
            axios.post(`${constants.baseApiUrl}Document/AddOrUpdateGridHeaders?nodeId=${this.nodeId}`, gridData)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert('Successfully', 'success');
                        this.GetAllGrid()
                        this.gridHeadersDilaog = false   
                    }
                })
                .catch((err) => {
                    console.warn(err);
                })
                .finally(() => {
                    window.hideLoading();
                });
         },
      GetAllGrid() { 
       
            axios.get(`${constants.baseApiUrl}Document/GetAllGridHeaders?nodeId=${this.nodeId}`)
            .then((res) => {                 
                if (res.data !== null && res.data !== '') {
                    
                    this.selectedItemGrid=(res.data.map(item => ({ ...item , show: item.show === "true" }))) 

                    this.selectedItemGridWithOutTranslation=this.selectedItemGrid
                    this.selectedItemGrid.forEach(item => {
                     item.text =  window.translate(item.text);  // Reset the text with the translated value
                    });
                   

                  
                    this.grid_headers = this.selectedItemGrid
                    .filter(item => item.show)
                    .map(item => ({ ...item }));   
                    //this.grid_headers.push({ text: "Show All",width: '5%',value: 'id', sortable: false, show: true},)
                     //if (this.shouldShowExpand())
                      // this.grid_headers.unshift({ text: this.$t('res_Label_Expand'),value: 'data-table-expand', width:'5px', sortable: false, show: true})
                        
                      //console.log("GetAllGridHeaders");
                    //console.log(this.grid_headers);
                    this.gridHeadersDilaog = false 
                

                }   if (this.shouldShowExpand())
                       this.grid_headers.unshift({ text: this.$t('res_Label_Expand'),value: 'data-table-expand', width:'5px', sortable: false, show: true})
                        
            })
            .catch((err) => {
                console.warn(err);
            })
            .finally(() => {
                window.hideLoading();
                });
        },
        closeNewTrackerDialog() { 
				this.visualTrackingDialogNew = false;
		},
        exportToExcelOrPdf(exportType) {
            this.isExport = true;
            this.exportType = exportType;
            this.getItemsForSelectedInbox(true)
        },
        signDocument() {
            let transferIds = this.selected.map(item => item.transferId).join(',') || this.selectedItem.item.transferId;
            let documentIds = this.selected.map(item => item.documentId).join(',') || this.selectedItem.item.documentId;
  
            this.propertyBag.documentId =documentIds //this.selectedItem.item.documentId
            this.propertyBag.transferId =transferIds //this.selectedItem.item.transferId
            this.propertyBag.delegationId = this.selected_node.delegationId

            const isUAEPassEnabled = constants.signUsingUAEPassEnabled && ((this.selectedItem.item.isUAEPassEnabled != null && this.selectedItem.item.isUAEPassEnabled) || this.selectedItem.item.templateId == null || this.selectedItem.item.templateId == "")
            const isDocusignEnabled = constants.signUsingDocusignEnabled

            if (isUAEPassEnabled || isDocusignEnabled)
                this.selectSignMethodFormDialog = true
            else
            {
            this.signFormDialog = true
            }
        },
        refreshAfterClosingSignDialog() {
            this.signFormDialog = false
            this.refreshPage();
        },
        refreshAfterClosingSignMethodSelect() 
        {
            this.selectSignMethodFormDialog = false
            // this.previewCorrespondence(this.itemToBeUpdated)
            window.location.reload
        },
        closeSignFormDialog() {
            this.signFormDialog = false
        },
        closeSelectSignMethodFormDialog() 
        {
            this.selectSignMethodFormDialog = false
        },
        closeSignMethodSelectAndOpenSignWithPin() 
        {
            this.selectSignMethodFormDialog = false
            this.selectSignMethodFormDialog = false
            this.signFormDialog = true
        },
        IsCced() {
            return this.selectedItem && (this.selectedItem.item.purposeId == 4 || this.selectedItem.item.cCed == true)
        },
        callback() {
            //console.log('callback from correspondence dialog')
        },
        initPageOnNodeIdChange() {
            this.openPreviewPane = false
            this.inboxes = []
            this.inboxes.push({ id: 1, name: this.getInboxName(this.isLanguageEn, 0), inboxId: this.nodeId, delegationId: 0, count: 0 })

            const intervalId = setInterval(() => {
                if (constants.isDelegationsLoaded == true) {
                    clearInterval(intervalId);
                    constants.delegations.forEach((delegation) => {
                        if (delegation.nodeIds != null && delegation.nodeIds != '') {
                            delegation.nodeIds.split(',').forEach((nodeIdItem) => {
                                if (this.nodeId === parseInt(nodeIdItem)) {
                                    var newDelegationNode = {
                                        id: this.inboxes.length + 1,
                                        fullname: delegation.fromUser.trim(),
                                        name: delegation.fromUserFirstName.trim() + "'s " + this.getInboxName(this.isLanguageEn, 1),
                                        inboxId: this.nodeId,
                                        delegationId: delegation.id,
                                        count: 0
                                    };
                                    if (this.isLanguageEn)
                                        newDelegationNode.name = delegation.fromUserFirstName.trim() + "'s " + this.getInboxName(this.isLanguageEn, 1);
                                    else
                                        newDelegationNode.name = this.getInboxName(this.isLanguageEn, 1) + " الخاص بـ " + delegation.fromUserFirstName.trim();

                                    this.inboxes.push(newDelegationNode)

                                    this.getItemsCountForSelectedInbox(this.nodeId, delegation.id, (count) => { newDelegationNode.count = count })
                                }
                            });
                        }
                    });
                }
            }, 100);

            this.selected_index = 0
            this.selected_node = this.inboxes[0]
            this.clearFiltersWithoutinitPage(0);
            window.refreshInbxGrid = this.initPage
        },
        initPage(ifGrid) {
            // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup
            if (document.querySelectorAll('.v-application--is-rtl').length)
            this.isLanguageEn = false
        if (ifGrid==0)
        {
            this.pageIndex = 0
        }
        if(this.selectedItemGrid.length == 0){
          this.GetAllGrid()
        }
                if (window["inboxHeaders"]) { 
                    window.inboxHeaders[this.nodeId].forEach(h => {
                        h.text = window.translate(h.text);
                    });
                    this.grid_headers = window.inboxHeaders[this.nodeId];
                } else {
                                
                    if (this.nodeId == 1 && this.selectedItemGrid.length == 0) // draft
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	            width: '40%',       value: 'subject',          		sortable: true , show: true},
                            { text: window.translate("res_MenuItems_ReferenceNumber"),      width: '30%',       value: 'referenceNumber',       sortable: true , show: true },
                            { text: window.translate("res_GridHeaders_CreatedDate"),        width: '30%',       value: 'createdDate',           sortable: true , show: true},
                            { text: window.translate("res_Label_Overdue"),                  width: '9%',        value: 'Overdue',               sortable: false, show: false },
                            { text: window.translate('res_Label_Privacy'),                  width: '25%',       value: 'privacy',               sortable: false ,show: false},
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.grid_headers.push({ text: window.translate("res_GridHeaders_ProjectNumber"), width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractNumber"), width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractName"), width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }

                        this.selectedItemGrid = this.grid_headers;
                        this.grid_headers = this.grid_headers.filter(item => item.show === true);
                        this.selectedItemGridWithOutTranslation= [
                            { text: "res_Label_Subject",    	            width: '40%',       value: 'subject',          		sortable: true , show: true},
                            { text:"res_MenuItems_ReferenceNumber",      width: '30%',       value: 'referenceNumber',       sortable: true , show: true },
                            { text: "res_GridHeaders_CreatedDate",        width: '30%',       value: 'createdDate',           sortable: true , show: true},
                            { text: "res_Label_Overdue",                  width: '9%',        value: 'Overdue',               sortable: false, show: false },
                            { text: 'res_Label_Privacy',                  width: '25%',       value: 'privacy',               sortable: false ,show: false},
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.selectedItemGridWithOutTranslation.push({ text: "res_GridHeaders_ProjectNumber", width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractNumber", width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractName", width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }
                        


                    }
                    else if (this.nodeId == 2  && this.selectedItemGrid.length == 0) // Inbox = 2&& this.selectedItemGrid.length == 0
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	        width: '21%',       value: 'subject',          		sortable: true ,show:true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '20%',       value: 'referenceNumber',       sortable: true ,show:true},
                            { text: window.translate("res_Label_Overdue"),              width: '6%',        value: 'overdue',               sortable: false,show:true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '7%',        value: 'dueDate',           	sortable: true ,show:true},
                            { text: window.translate("res_Label_Sender"),    		    width: '11%',       value: 'sender',          		sortable: true ,show:true},
                            { text: window.translate("res_Label_From"),    		        width: '11%',       value: 'senderUser',          	sortable: true ,show:true},
                            { text: window.translate("res_GridHeaders_ActionType"),     width: '8%',        value: 'purpose',           	sortable: true ,show:true},
                            { text: window.translate("res_Label_Status"),               width: '8%',        value: 'status',                sortable: true ,show:true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '12%',        value: 'recievedDate',          sortable: true ,show:true},
                            { text: window.translate("res_Label_OpenDate"),             width: '2%',        value: 'openedDate',            sortable: false,show:false},
                            { text: window.translate("res_Label_CloseDate"),            width: '1%',        value: 'closedDate',            sortable: false,show:false},
                            { text: window.translate("res_Label_Category"),    	        width: '8%',        value: 'categoryId',          	sortable: false,show:false},
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.grid_headers.push({ text: window.translate("res_GridHeaders_ProjectNumber"), width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractNumber"), width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractName"), width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }
                        this.selectedItemGrid = this.grid_headers
                        
                        this.grid_headers = this.grid_headers.filter(item=>item.show === true)

                        this.selectedItemGridWithOutTranslation= [
                            { text: "res_Label_Subject",    	        width: '21%',       value: 'subject',          		sortable: true ,show:true},
                            { text: "res_Label_ReferencenNo",    	    width: '20%',       value: 'referenceNumber',       sortable: true ,show:true},
                            { text:"res_Label_Overdue",              width: '6%',        value: 'overdue',               sortable: false,show:true},
                            { text: "res_GridHeaders_DueDate",        width: '7%',        value: 'dueDate',           	sortable: true ,show:true},
                            { text: "res_Label_Sender",    		    width: '11%',       value: 'sender',          		sortable: true ,show:true},
                            { text: "res_Label_From",    		        width: '11%',       value: 'senderUser',          	sortable: true ,show:true},
                            { text: "res_GridHeaders_ActionType",     width: '8%',        value: 'purpose',           	sortable: true ,show:true},
                            { text: "res_Label_Status",               width: '8%',        value: 'status',                sortable: true ,show:true},
                            { text: "res_GridHeaders_Recieved",       width: '12%',        value: 'recievedDate',          sortable: true ,show:true},
                            { text: "res_Label_OpenDate",             width: '2%',        value: 'openedDate',            sortable: false,show:false},
                            { text:"res_Label_CloseDate",            width: '1%',        value: 'closedDate',            sortable: false,show:false},
                            { text: "res_Label_Category",    	        width: '8%',        value: 'categoryId',          	sortable: false,show:false},
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.selectedItemGridWithOutTranslation.push({ text: "res_GridHeaders_ProjectNumber", width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractNumber", width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractName", width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }
                        //this.selectedItemGrid=this.selectedItemGridWithOutTranslation;
                    }
                    else if (this.nodeId == 10 && this.selectedItemGrid.length == 0) // CCed = 10
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	        width: '30%',       value: 'subject',          		sortable: true ,show: true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '30%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: window.translate("res_Label_Sender"),    		    width: '8%',        value: 'sender',          		sortable: true ,show: true},
                            { text: window.translate("res_Label_From"),    		        width: '8%',        value: 'senderUser',          	sortable: true ,show: true},
                            { text: window.translate("res_Label_Status"),               width: '8%',        value: 'status',                sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: window.translate("res_Label_Overdue"),              width: '1%',        value: 'overDue',               sortable: false,show: false},
                            { text: window.translate("res_Label_Instruction"),          width: '8%',        value: 'transferInstruction',   sortable: false,show: false},
                        ];
                        this.selectedItemGrid = this.grid_headers
                        this.grid_headers =this.grid_headers.filter(item=>item.show === true)

                        this.selectedItemGridWithOutTranslation=[
                            { text: "res_Label_Subject",    	        width: '30%',       value: 'subject',          		sortable: true ,show: true},
                            { text: "res_Label_ReferencenNo",    	    width: '30%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: "res_GridHeaders_DueDate",        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: "res_Label_Sender",    		    width: '8%',        value: 'sender',          		sortable: true ,show: true},
                            { text: "res_Label_From",    		        width: '8%',        value: 'senderUser',          	sortable: true ,show: true},
                            { text: "res_Label_Status",               width: '8%',        value: 'status',                sortable: true ,show: true},
                            { text: "res_GridHeaders_Recieved",       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: "res_Label_Overdue",              width: '1%',        value: 'overDue',               sortable: false,show: false},
                            { text: "res_Label_Instruction",          width: '8%',        value: 'transferInstruction',   sortable: false,show: false},
                        ];
                    }
                    else if (this.nodeId == 6 && this.selectedItemGrid.length == 0) // Sent
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	        width: '25%',       value: 'subject',          		sortable: true ,show: true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '15%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recipient"),      width: '8%',        value: 'recipient',          	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_SentTo"),         width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_ActionType"),     width: '5%',        value: 'purpose',           	sortable: true ,show: true},
                            { text: window.translate("res_Label_Status"),               width: '8%',        value: 'status',                sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: window.translate("res_Label_Overdue"),              width: '1%',        value: 'overdue',               sortable: false,show: false },
                            //{ text: "ShowOthers", width: '4%', value: 'ShowOthers', sortable: false, show: true }
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.grid_headers.push({ text: window.translate("res_GridHeaders_ProjectNumber"), width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractNumber"), width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: window.translate("res_GridHeaders_ContractName"), width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }
                        
                        this.selectedItemGrid = this.grid_headers
                        this.grid_headers =this.grid_headers.filter(item=>item.show === true)
                        //console.log(this.grid_headers)
                        this.selectedItemGridWithOutTranslation=[
                            { text: "res_Label_Subject",    	        width: '25%',       value: 'subject',          		sortable: true ,show: true},
                            { text: "res_Label_ReferencenNo",    	    width: '15%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: "res_GridHeaders_DueDate",        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: "res_GridHeaders_Recipient",      width: '8%',        value: 'recipient',          	sortable: true ,show: true},
                            { text: "res_GridHeaders_SentTo",         width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: "res_GridHeaders_ActionType",     width: '5%',        value: 'purpose',           	sortable: true ,show: true},
                            { text: "res_Label_Status",               width: '8%',        value: 'status',                sortable: true ,show: true},
                            { text: "res_GridHeaders_Recieved",       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: "res_Label_Overdue",              width: '1%',        value: 'overdue',               sortable: false,show: false },
                            //{ text: "ShowOthers", width: '4%', value: 'ShowOthers', sortable: false, show: true }
                        ];
                        if (window.enableGridDataForAdPorts == true) {
                            this.selectedItemGridWithOutTranslation.push({ text: "res_GridHeaders_ProjectNumber", width: '20%', value: 'projectNumber', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractNumber", width: '20%', value: 'contractName', sortable: true, show: false },
                                                   { text: "res_GridHeaders_ContractName", width: '20%', value: 'contractNumber', sortable: true, show: false }
                                                   );
                        }
                        
                    }
                    else if (this.nodeId == 8 && this.selectedItemGrid.length == 0) // Archived
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	        width: '24%',       value: 'subject',          		sortable: true ,show: true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '24%',       value: 'referenceNumber',      sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recipient"),      width: '10%',       value: 'recipient',          	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_SentTo"),    	    width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_ActionType"),     width: '10%',       value: 'purpose',           	sortable: true ,show: true},
                            { text: window.translate("res_Label_Status"),               width: '7%',        value: 'status',                sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '7%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: window.translate("res_Label_Instruction"),          width: '1%',        value: 'instruction',           sortable: false,show: false},
                            { text: window.translate("res_Label_Overdue"),              width: '4%',        value: 'overdue',               sortable: false,show: false},
                        ];
                        this.selectedItemGrid = this.grid_headers
                        this.grid_headers = this.grid_headers.filter(item=>item.show === true)

                        this.selectedItemGridWithOutTranslation=[
                            { text:"res_Label_Subject",    	        width: '24%',       value: 'subject',          		sortable: true ,show: true},
                            { text: "res_Label_ReferencenNo",    	    width: '24%',       value: 'referenceNumber',      sortable: true ,show: true},
                            { text: "res_GridHeaders_DueDate",        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: "res_GridHeaders_Recipient",      width: '10%',       value: 'recipient',          	sortable: true ,show: true},
                            { text: "res_GridHeaders_SentTo",    	    width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: "res_GridHeaders_ActionType",     width: '10%',       value: 'purpose',           	sortable: true ,show: true},
                            { text: "res_Label_Status",               width: '7%',        value: 'status',                sortable: true ,show: true},
                            { text: "res_GridHeaders_Recieved",       width: '7%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: "res_Label_Instruction",          width: '1%',        value: 'instruction',           sortable: false,show: false},
                            { text: "res_Label_Overdue",              width: '4%',        value: 'overdue',               sortable: false,show: false},
                        ];
                    }
                    else if (this.nodeId == 9 && this.selectedItemGrid.length == 0) // Follow-up
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    		    width: '24%',       value: 'subject',          		sortable: true ,show: true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '24%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recipient"),      width: '10%',       value: 'recipient',          	sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_SentTo"),    	    width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_ActionType"),     width: '8%',        value: 'purpose',             	sortable: true ,show: true},
                            { text: window.translate("res_Label_Status"),               width: '8%',        value: 'status',                 sortable: true ,show: true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: window.translate("res_Label_Instruction"),          width: '1%',        value: 'transferInstruction',   sortable: false,show: false },
                            { text: window.translate("res_Label_Overdue"),              width: '7%',        value: 'overdue',               sortable: false,show: false },
                        ];
                        this.selectedItemGrid = this.grid_headers
                        this.grid_headers =this.grid_headers.filter(item=>item.show === true)
                        this.selectedItemGridWithOutTranslation=[
                            { text: "res_Label_Subject",    		    width: '24%',       value: 'subject',          		sortable: true ,show: true},
                            { text: "res_Label_ReferencenNo",    	    width: '24%',       value: 'referenceNumber',       sortable: true ,show: true},
                            { text: "res_GridHeaders_DueDate",        width: '8%',        value: 'dueDate',           	sortable: true ,show: true},
                            { text:"res_GridHeaders_Recipient",      width: '10%',       value: 'recipient',          	sortable: true ,show: true},
                            { text:"res_GridHeaders_SentTo",    	    width: '10%',       value: 'sentTo',          	    sortable: true ,show: true},
                            { text: "res_GridHeaders_ActionType",     width: '8%',        value: 'purpose',             	sortable: true ,show: true},
                            { text: "res_Label_Status",               width: '8%',        value: 'status',                 sortable: true ,show: true},
                            { text: "res_GridHeaders_Recieved",       width: '8%',        value: 'recievedDate',          sortable: true ,show: true},
                            { text: "res_Label_Instruction",          width: '1%',        value: 'transferInstruction',   sortable: false,show: false },
                            { text: "res_Label_Overdue",              width: '7%',        value: 'overdue',               sortable: false,show: false },
                        ];
                }
                else if (this.nodeId == 13 && this.selectedItemGrid.length == 0) // Completed = 13
                    {
                        this.grid_headers = [
                            { text: window.translate("res_Label_Subject"),    	        width: '21%',       value: 'subject',          		sortable: true ,show:true},
                            { text: window.translate("res_Label_ReferencenNo"),    	    width: '20%',       value: 'referenceNumber',       sortable: true ,show:true},
                            { text: window.translate("res_Label_Overdue"),              width: '6%',        value: 'overdue',               sortable: false,show:true},
                            { text: window.translate("res_GridHeaders_DueDate"),        width: '7%',        value: 'dueDate',           	sortable: true ,show:true},
                            { text: window.translate("res_Label_Sender"),    		    width: '11%',       value: 'sender',          		sortable: true ,show:true},
                            { text: window.translate("res_Label_From"),    		        width: '11%',       value: 'senderUser',          	sortable: true ,show:true},
                            { text: window.translate("res_GridHeaders_ActionType"),     width: '8%',        value: 'purpose',           	sortable: true ,show:true},
                            { text: window.translate("res_Label_Status"),               width: '8%',        value: 'status',                sortable: true ,show:true},
                            { text: window.translate("res_GridHeaders_Recieved"),       width: '12%',        value: 'recievedDate',          sortable: true ,show:true},
                            { text: window.translate("res_Label_OpenDate"),             width: '2%',        value: 'openedDate',            sortable: false,show:false},
                            { text: window.translate("res_Label_CloseDate"),            width: '1%',        value: 'closedDate',            sortable: false,show:false},
                            { text: window.translate("res_Label_Category"),    	        width: '8%',        value: 'categoryId',          	sortable: false,show:false},
                        ];
                        this.selectedItemGrid = this.grid_headers
                        this.grid_headers =this.grid_headers.filter(item=>item.show === true)

                           this.selectedItemGridWithOutTranslation=[
                            { text: "res_Label_Subject",    	        width: '21%',       value: 'subject',          		sortable: true ,show:true},
                            { text: "res_Label_ReferencenNo",    	    width: '20%',       value: 'referenceNumber',       sortable: true ,show:true},
                            { text: "res_Label_Overdue",              width: '6%',        value: 'overdue',               sortable: false,show:true},
                            { text: "res_GridHeaders_DueDate",        width: '7%',        value: 'dueDate',           	sortable: true ,show:true},
                            { text: "res_Label_Sender",    		    width: '11%',       value: 'sender',          		sortable: true ,show:true},
                            { text: "res_Label_From",    		        width: '11%',       value: 'senderUser',          	sortable: true ,show:true},
                            { text: "res_GridHeaders_ActionType",     width: '8%',        value: 'purpose',           	sortable: true ,show:true},
                            { text: "res_Label_Status",               width: '8%',        value: 'status',                sortable: true ,show:true},
                            { text: "res_GridHeaders_Recieved",       width: '12%',        value: 'recievedDate',          sortable: true ,show:true},
                            { text: "res_Label_OpenDate",             width: '2%',        value: 'openedDate',            sortable: false,show:false},
                            { text: "res_Label_CloseDate",            width: '1%',        value: 'closedDate',            sortable: false,show:false},
                            { text: "res_Label_Category",    	        width: '8%',        value: 'categoryId',          	sortable: false,show:false},
                        ];
                    }
            }
            this.getItemsForSelectedInbox(true);
        },
        nodeClicked(item) {
            this.selected = []
            this.selected_index = item.id - 1
            this.selected_node = item
            this.getItemsForSelectedInbox(true) 
        },
        CreateReplyDocument(docId){
            this.messagesUtil.dispatchEvent({ key: "createOutgoingOnIncoming", documentId: docId });
        },
        getItemsForSelectedInbox(isResetPaging) 
        {
            if (isResetPaging) {
                this.pagingData.pageIndex = 0;
            }
           
            var formData = new FormData();
            formData.append('nodeId', this.nodeId)
            if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id))
                formData.append('delegationId', this.selected_node.delegationId)
            else
                formData.append('delegationId', 0)
            formData.append('pageIndex', this.pagingData.pageIndex)
            formData.append('pageSize', this.pagingData.pageSize)
            formData.append('sortBy', this.sortBy)
            formData.append('sortDir', (this.sortDesc ? 'desc' : 'asc'))
            formData.append('filter_Unopened_Document', this.filter_Unopened_Document)
            formData.append('filter_Overdue_Document', this.filter_Overdue_Document)

            if (!utils.CheckIfNullOrEmpty(this.filter_reference_number))
                formData.append('filter_reference_number', this.filter_reference_number)

            if (utils.CheckIfNullOrEmpty(this.filter_created_date) == false)
                formData.append('filter_created_date', this.filter_created_date)

            if (utils.CheckIfNullOrEmpty(this.filter_subject) == false)
                formData.append('filter_subject', this.filter_subject)

            if (utils.CheckIfNullOrEmpty(this.filter_due_date) == false)
                formData.append('filter_due_date', this.filter_due_date)

            if (utils.CheckIfNullOrEmpty(this.filter_sender) == false && utils.CheckIfNullOrEmpty(this.filter_sender.id) == false)
                if (this.filter_sender.id != 0)
                    formData.append('filter_sender', this.filter_sender.id)

            if (utils.CheckIfNullOrEmpty(this.filter_purpose) == false && utils.CheckIfNullOrEmpty(this.filter_purpose.id) == false)
                if (this.filter_purpose.id != 0)
                    formData.append('filter_purpose', this.filter_purpose.id)

            if (utils.CheckIfNullOrEmpty(this.filter_category) == false && utils.CheckIfNullOrEmpty(this.filter_category.id) == false)
                if (this.filter_category.id != 0)
                    formData.append('filter_category', this.filter_category.id)
            
            if (utils.getParameterByName('categoryId') != null) 
            {
                this.hide_filter_category = true
                formData.append('filter_category', utils.getParameterByName('categoryId'))
            }

            window.showLoading();
            if (this.isExport) {
                formData.append('isExport', this.isExport);
                formData.append('exportType', this.exportType);

                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios({
                    url: constants.baseApiUrl + 'Transfer/List',
                    method: 'POST',
                    data: formData,
                    responseType: 'blob',
                })
                    .then((res) => {
                        //console.log("getting inbox");
                        //console.log(res);
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch((err) => window.hideLoading())
                    .finally(() => window.hideLoading())
                this.isExport = false;
                this.exportType = 0;
            } else {
                this.correspondences = [];
                const url = new URL(window.location.href);
                var categoryId = url.searchParams.get("categoryId");
                categoryId = categoryId !==null? categoryId : 0
                axios.post(constants.baseApiUrl + `Transfer/List/?categoryId=${categoryId}`, formData)
                    .then((res) => {
                     //console.log("get data 1");
                        this.correspondences = res.data;
                        //console.log(this.nodeId);
                        if (this.shouldShowExpand()){
                            this.correspondences = this.createUniqueList(res.data);
                            this.nonGroupedCorrespondences = res.data;
                           //console.log("getting the rows")
                           //console.log(res.data)
                           // console.log(this.correspondences)
                        }
                        
                        //this.correspondences = this.createUniqueList(res.data);
                        formData.append('getCountOnly', true)
                        axios.post(constants.baseApiUrl + 'Transfer/List', formData)
                            .then((res) => {
                                if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)) {
                                    var index = this.inboxes.findIndex(x => x.id == this.selected_node.id)
                                    //this.inboxes[index].count = res.data;
                                     if( res.data >  this.correspondences.length) 
                                      {  
                                        this.inboxes[index].count=res.data
                                     }else
                                         this.inboxes[index].count =  res.data;
                                }
                                else
                                {
                                     if( res.data>  this.correspondences.length)  
                                       this.inboxes[0].count=res.data
                                        else
                                         this.inboxes[0].count =  res.data;
                                    //this.inboxes[0].count = res.data
                                    }
                              
                            });

                        setTimeout(() => { this.showTooltips() }, 1000);
                    })
                    .catch((err) => console.log(err))
                    .finally(() => window.hideLoading())
            }
        },
        getItemsCountForSelectedInbox(nodeId, delegationId, successHandler) {
            var formData = new FormData();
            formData.append('nodeId', nodeId)
            formData.append('delegationId', delegationId)
            formData.append('pageIndex', this.pagingData.pageIndex)
            formData.append('pageSize', this.pagingData.pageSize)
            formData.append('getCountOnly', true)

            axios.post(constants.baseApiUrl + 'Transfer/List', formData)
                .then((res) => {
                    //console.log("get data 2");
                        //console.log(res.data);
                    successHandler(res.data)
                });
        },
        getPinned(item) 
        {
            var isNotRead = (this.getRowClass(item).lastIndexOf('tr-bold') != -1 ? true : false)
            if (isNotRead)
                return 'mdi-not-read'
            else
                return ''
        },
        getStatusClass(item) 
        {
            if (constants.statusesEnum.Completed.value == item.statusId)
                return constants.statusesEnum.Completed.data().classColor;

            return '';
        },
        getPurposeColor(item)
        {
            if (window.transfer_purposes != undefined)
            {
                var purposeItem = window.transfer_purposes.find(x => x.id == item.purposeId)
                if (purposeItem != null)
                    return purposeItem.color
            }
            return ''
        },
        getFollowUp(flag) 
        {
            if (flag)
                return 'mdi-follow-up'
            else
                return 'mdi-flag'
        },
        getAttachment(hasAttachment) {
            if (hasAttachment == true) return 'mdi-attachment'
        },
        openOptionPane(menuOption) {
            if (menuOption == 3)
                this.showMenu = true;
        },
        previewCorrespondence(item, row) {
            //console.log("previewcor");
            //console.log(item);
            this.selected = []
            this.selectedItem = { 'item': item, 'value': true }
            this.openPreviewPane = true
            this.showActionsBtns = false;
            this.isSecretNote = this.selectedItem.item.isSecretNote;
            this.toUserId=this.selectedItem.item.toUserId;
            if (!item.openedForPreview) {
                item.openedForPreview = true;
            }
            if (!item.transferId) {
                item.transferId = 0;
            }
            
            if (item.attachmentId == null || item.attachmentId == undefined) {
                this.empty_viewer = true
            }
            else {
                this.empty_viewer = false
                window.setViewerData(item.attachmentId, item.documentId, null, item.subject + '-' + item.referenceNumber);
                this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                    '&viewerMode=collapsed&r=' + new Date().getTime()
            }

            if (item.transferId > 0) {
                var context = this
                var showTransferNote = (item.openedDate == null ? true : false)
                setTimeout(() => {
                    if (context.$refs.transferNotesIcon)
                        context.$refs.transferNotesIcon.setTransferNotes(item.transferCreatedByUserId, item.transferInstruction, showTransferNote)
                }, 50);

                // mark transfer as read, only when opened from inbox
                if (this.nodeId == 2)
                    axios.post(constants.baseApiUrl + 'Transfer/MarkTransferAsRead?transferId=' + item.transferId + '&delegationId=' + this.selected_node.delegationId, null)
                        .then(() => { /*console.log('MarkedTransferAsRead')*/ })
                        .catch(error => console.log(error));
            }

            this.handleToolBarWindowResize(false);

            if (this.nodeId == 2 || this.nodeId == 1) {
                   axios.get(constants.baseApiUrl + 'Document/CheckHasPermissionToSign?documentId=' + item.documentId + '&delegationId=' + this.selected_node.delegationId, null)
                    .then(response => {
                        this.canSignDocument = response.data;
                       this.handleToolBarWindowResize(true);
                    })
                    .catch(error => console.log(error));
            } else {
                this.showActionsBtns = true;
                this.handleToolBarWindowResize(true);
            }

            if (window.refreshUnOpenedDocument) {
                window.refreshUnOpenedDocument();
            }

        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        openFullView() {
            //  Draft = 1, Inbox = 2, Sent = 6, Archived = 8, Follow-up = 9
            if (this.nodeId == 1)
                this.viewMode = 'edit'
            else if (this.nodeId == 2)
                this.viewMode = 'edit_new'
            else if (this.nodeId == 6 || this.nodeId == 8 || this.nodeId == 9)
                this.viewMode = 'readonly'
            var item = this.selectedItem.item
            if (item.statusId == 1) // Draft
            {
                this.delegationId = 0;
             
                this.documentId = item.id
                this.correspondenceDialog = true
                if( constants.enableConfigrationSignature==true){
                this.nodeDelegationId=this.selected_node.delegationId;
                 }
                 else{
                    this.nodeDelegationId=0;
                 }
            }
            else {
                this.delegationId = this.selected_node.delegationId
                this.nodeDelegationId=this.selected_node.delegationId;

                this.transferId = item.transferId
                this.documentId = item.documentId
                this.correspondenceDialog = true
                // setTimeout(() => {
                //     document.getElementById('correspondenceDialogEmptyDiv').parentElement.classList.add('view-mode-dialog');
                //     document.getElementById('correspondenceDialogEmptyDiv').parentElement.parentElement.classList.add('transparentBg');
                // }, 10);

            }
            if (this.nodeId == 9) {
                this.toEmail = item.sentToEmail
                this.emailCC = item.sentToManagerEmail
            }

            this.closePreview();
        },
        cancelFollowup() {
            var transferId = this.selectedItem.item.transferId

            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_FollowUpCancelConfirmation"),
                () => {
                    var methodUrl = "Followup/CancelFollowup?transferId=" + transferId
                    axios.post(constants.baseApiUrl + methodUrl, null, { headers: constants.headers })
                        .then(() => {
                            window.showAlert("res_Msgs_FollowUpCancellation", 'success')
                            this.refreshPage()
                        })
                        .catch(err => console.warn(err))
                },
                () => { })
        },
        itemSelected(item) {
   if (this.selected.length > 0)
            {
                this.openPreviewPane = false
            }
                if (item.value == true) {
                    this.selectedItem = item
                    if (this.nodeId == 2 || this.nodeId == 1) {
                        axios.get(constants.baseApiUrl + 'Document/CheckHasPermissionToSign?documentId=' + this.selectedItem.item.documentId + '&delegationId=' + this.selected_node.delegationId, null)
                            .then(response => {
                                this.selectedItem.item.canSign = response.data;
                            })
                            .catch(error => console.log(error));
                    }
                }
                else {
                    this.selectedItem = null
                }
        },
        closePreview() {
            //this.selectedItem = null
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.openPreviewPane = false
            this.openOwnerDialog = false
        },
        refreshPage() {
            this.selected = [];
            this.closePreview();
            this.initPage(0);
        },
        refreshPageGrid() {
            this.selected = []
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.initPage(1);
        },
        getInboxName(isLanguageEn, isDelegation) {
            switch (this.nodeId) {
                case 1:
                    return isLanguageEn ? 'Draft' : 'المسودات';
                case 2:
                    return isLanguageEn ? 'Inbox' : 'الوارد';
                case 6:
                    return isLanguageEn ? 'Sent' : 'المرسل';
                case 7:
                    return isLanguageEn ? 'Hidden' : 'المخفي';
                case 8:
                    return isLanguageEn ? 'Archive' : 'الأرشيف';
                case 9:
                    return isLanguageEn ? 'Follow up' : 'متابعة';
                case 10:
                    return isLanguageEn ? 'Cced Inbox' : 'النسخ';
                default:
                    return 'Inbox'
            }
        },
        deleteDraftDocument() {
            if (this.selectedItem.item.statusId != 1) {
                window.showAlert('res_Msgs_CantDeleteAlreadyRegisteredDocument', 'error');
                return;
            }

            window.showLoading()
            axios.post(constants.baseApiUrl + 'Document/Delete?documentId=' + this.selectedItem.item.id)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert('res_Msgs_DraftDocumentDeleted', 'success')

                        this.openPreviewPane = false;
                            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
                        this.$nextTick(() => {
                            this.initPage(0)
                        });
                    }
                    else {
                        window.showAlert('res_Msgs_DraftDocumentDeletionFailed', 'error')
                    }
                })
                .catch((err) => { console.log(err); window.hideLoading(); })
                .finally(() => { window.hideLoading(); })

        },
        DismissCced() {
            window.showInformation('Confirmation', window.translate("res_Msgs_TransferDismissConfirmation"),
                () => {
                    window.showLoading()
                    axios.get(constants.baseApiUrl + 'Transfer/DismissCcedTransfer?transferId=' + this.selectedItem.item.transferId)
                        .then(res => {
                            if (res.data != null && res.data > 0) {
                                window.showAlert('res_Msgs_TransferDismiss', 'success')
                                this.refreshPage();
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => { window.hideLoading(); })
                });
        },
        closeCorrespondenceDialog() {
            this.delegationId = 0
            this.documentId = 0
            this.transferId = 0
            this.correspondenceDialog = false

            this.initPage(0)
        },
        OpenTransferForm(action) {
            if (action == 'SendCC' || action == 'ForwardCC'){
                this.canBeSignedByExternalUser = true
            }
            this.delegationId = this.selected_node.delegationId
            this.rejected = false
            this.forwardCC = false
            this.recipientDisabled = false
            this.hideTransferCC=false
            this.readOnlyPurpose=false
            const transferIds = this.selected.map(item => item.transferId);
            this.transferId = transferIds.length > 0 ? transferIds.join(',') : this.selectedItem.item.transferId;
            const documentIds = this.selected.map(item => item.documentId);
            this.documentId = documentIds.length > 0 ? documentIds.join(',') : this.selectedItem.item.documentId;
            this.signForm = false
            if (action == 'Endorse') {
                this.transferSuccessMessage = 'res_Msgs_DocumentEndorsed'
                this.transferFormHeader = window.translate("res_MenuItems_Endorse")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                this.purpose = { id: 8, name: 'For Signature' }
                }
                
                //this.purpose = { id: 15, name: 'For Endorsement' }
                this.getNextReceiver(false, true)
            }
            else if (action == 'Forward') {
                this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                this.checkForAttachmentsUploadMultiApproval = true
                this.transferFormHeader = window.translate("res_MenuItems_Forward")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else if(this.selectedItem.item.categoryId==6 && this.selectedItem.item.purposeId==7 &&this.selectedItem.item.transferId != null && this.selectedItem.item.transferId != undefined&&this.selectedItem.item.transferId!=0)
                 {
                         if(this.isLanguageEn)
                         this.purpose = { id: 11, name:'Approved'  }
                         else  
                          this.purpose = { id: 11, name:'تمت الموافقة'  }
                 }                
                else {
                        if(this.isLanguageEn)
                        this.purpose = { id: 3, name: 'For Action' }  
                        else  
                        this.purpose = { id: 3, name: 'لإجراء اللازم' } 
                }
               
                this.getNextReceiver(false, false)
            }
            else if (action == 'ForwardCc') {
                this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                this.checkForAttachmentsUploadMultiApproval = true
                this.transferFormHeader = window.translate("res_MenuItems_Forward")
                this.purpose = { id: 10, name: 'Cced' }
                this.forwardCC=true
                //this.canBeSignedByExternalUser = true
                //this.getNextReceiver(false, false)
            }
             else if (action == 'SendCC') {
                this.transferSuccessMessage = 'res_Msgs_DocumentForwarded'
                this.checkForAttachmentsUploadMultiApproval = true
                this.transferFormHeader = window.translate("res_MenuItems_SendCC")
                this.purpose = { id: 10, name: 'Cced' }
                this.hideTransferCC=true
                this.readOnlyPurpose=true
                //this.canBeSignedByExternalUser = true
            }
            
            else if (action == 'Sign') {
                this.transferSuccessMessage = 'res_Msgs_DocumentSignedAndSent'
                this.transferFormHeader = window.translate("res_ButtonText_SignAndSend")

                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                this.purpose = { id: 8, name: 'For Signature' }
                }
                
               
                this.signForm = true
                this.getNextReceiver(true, false)
            }
            else if (action == 'Rejected') {
                this.transferSuccessMessage = 'res_Msgs_DocumentRejected'
                this.recipientDisabled = false
                this.rejected = true
                this.signForm = utils.checkCanSignDocument(this.selectedItem.item, this.selected_node.delegationId, this.canSignDocument);
                this.transferFormHeader = window.translate("res_DialogTitle_Rejected")
                this.purpose = { id: 12, name: 'Rejected' }
                this.GetInitiator(this.documentId)
            }
            else if (action == 'Send Back') {
                if(this.selectedItem.item.toUserId == null){
                    window.showAlert(this.$t('res_Msgs_CantSendBack'));
                    return;
                }
                this.transferSuccessMessage = 'res_Msgs_DocumentSentBack'
                this.recipientDisabled = true
                this.transferFormHeader = window.translate("res_MenuItems_SendBack")
                if (constants.client_version_Id == 'ADHA') {
                    this.purpose = { id: 0, name: '' }
                }
                else {
                this.purpose = { id: 3, name: 'For Action' }
                }
                
                this.signForm = false
                this.GetPreviousSender(this.transferId)
            }
            this.disableAdvancedTransfer = !this.selectedItem.item.isSigned;
            
            let missingOtherAttachments = this.selectedItem.item.hasOtherAttachments == 1;
            let missinglinkedDocuments  = this.selectedItem.item.hasLinked == 1;
            if( window.enableConfirmOntransferOtherInfo == true  &&
               (missinglinkedDocuments|| missingOtherAttachments) &&
               (this.selectedItem.item.transferId <= 0 || this.selectedItem.item.transferId== null)
              && this.selectedItem.item.categoryId == 2
             ){ 
                let missingData = [];
                if(missinglinkedDocuments)
                { missingData.push(this.$t('res_CardHeaders_LinkedEmails')); }
                if(missingOtherAttachments)
                { missingData.push(this.$t('res_Label_OtherAttachments')); }
                let customMessage = missingData.length == 1 ? missingData[0] : `(${missingData.join(',')})`;
                window.showInformation(
                this.$t('res_Msgs_Confirmation'),
                this.$t('res_Msgs_DocumentHasNoLinkedDocsAndOtherAttachments', { customMessage }),
                () => { this.transferFormDialog = true },
                () => {})
            }
            else{
                 this.transferFormDialog = true
            } 
            
            
        },
        closeTransferFormDialog() {
            this.closePreview()
            this.transferFormDialog = false
            this.disableAdvancedTransfer = true
            this.refreshPage()
        },
        handleFirstElement(data, tempItem) {
            if (data.length > 0) {
                var shouldAddTemp = true;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].isTemp
                        || data[i].id == undefined
                        || data[i].id == null) {
                        shouldAddTemp = false;
                        break;
                    }
                }
                if (shouldAddTemp) {
                    if (tempItem == undefined || tempItem == null) {
                        tempItem = { isTemp: true, name: 'temp' };
                    }
                    data = [tempItem, ...data];
                } else if (data.length == 1) {
                    data = [];
                }
            }
            return data;
        },
        getNextReceiver(isSign, isEndorse) {
            this.transferCC = []
            this.transferTo = null
            this.transferToMulti = []
            const documentIds = this.selected.map(item => item.documentId);
            this.documentId = documentIds.length > 0 ? documentIds.join(',') : this.selectedItem.item.documentId;
            defaultGet('Transfer/GetDocumentNextDefaultReceiver?docId=' + this.documentId + '&isSign=' + isSign + '&isEndorse=' + isEndorse +
             '&delegationId=' + this.selected_node.delegationId+'&purpose='+null,
                (res) => {
                    if (res.data != null && res.data != undefined) {
                        if (res.data.length > 0 && res.data[0].id != 0) {
                            var isMultiForwardEnabled = false
                            var notCcedElements = res.data.filter(x => x.isCced == false)
                            if (notCcedElements.length > 1)
                                isMultiForwardEnabled = true

                            res.data.forEach(element => {
                                var purposeName = ''
                                var selectedPurpose = constants.purposes.find(x => x.id == element.purpose)

                                if (selectedPurpose != undefined && selectedPurpose != null){
                                    purposeName = selectedPurpose.name
                                    if (constants.client_version_Id == 'ADHA') {
                                        this.purpose = { id: 0, name: '' }
                                }  
                                   else{
                                this.purpose = { id: element.purpose, name: purposeName }
                                        if(this.selectedItem.item.categoryId==6 && this.selectedItem.item.purposeId==7 &&this.selectedItem.item.transferId != null && this.selectedItem.item.transferId != undefined&&this.selectedItem.item.transferId!=0)
                                            {
                                               // this.purpose = { id: 11, name:'Approved'  }
                                                if(this.isLanguageEn)
                                                this.purpose = { id: 11, name:'Approved'  }
                                                else  
                                                this.purpose = { id: 11, name:'تمت الموافقة'  }
                                                var res = [...this.allTransferPurposes];
                                                const filterValues = ['Approved', 'Rejected'];
                                                // Use the filter method to get the specific values
                                                const filteredPurposes = [...this.allTransferPurposes].filter(purpose => filterValues.includes(purpose.name));
                                                this.mom_purpose_items =filteredPurposes;
                                                //console.log(" this.mom_purpose_items:"+ this.mom_purpose_items);
                                            }
                                        }
                                     }  
                                  
                                if (element.isCced)
                                    this.transferCC.push(element)
                                else {
                                      if(this.selectedItem.item.categoryId==6 && this.selectedItem.item.purposeId==7 &&this.selectedItem.item.transferId != null && this.selectedItem.item.transferId != undefined&&this.selectedItem.item.transferId!=0)
                                         {
                                           // this.GetInitiator(this.documentId)
                                          
                                          }

                                        else{
                                    if (element.name != "0") {
                                        if (isMultiForwardEnabled == false)
                                            this.transferTo = element
                                        else
                                            this.transferToMulti.push(element)
                                                }
                                            }
                                }
                            });

                            if (this.transferCC.length > 0) {
                                this.transferCC = this.handleFirstElement(this.transferCC, {});
                            }

                            if (this.transferToMulti.length > 0) {
                                this.transferToMulti = this.handleFirstElement(this.transferToMulti, { name: 'temp', isTemp: true });
                            } else {
                                this.transferToMulti = []
                            }

                        }

                    }
                }, this.handleError, true);
        },
        GetPreviousSender(transferId) {
            defaultGet('Transfer/GetPreviousSender?transferId=' + transferId,
                (res) => {
                    if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                        this.transferTo = res.data
                    }
                }, this.handleError, true);
        },
        GetInitiator(documentId) {
            defaultGet('Transfer/GetInitiator?documentId=' + documentId,
                (res) => {
                    if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                        this.transferTo = res.data
                    }
                }, this.handleError, true);
        },
        handleError(error) {
            this.loading = false
            console.log(error)
            window.showAlert('res_Msgs_ErrorOccured', 'error')
        },
        openVisualTracking() {  
            if (window.enableVisualTracker2 == true) { 
                
                this.visualTrackingDialogNew_selectedDocumentId = this.selectedItem.item.documentId;
                this.visualTrackingDialogNew = true;  
            }
            else
            {
                this.signingHistoryDialog = false
                // this.visualTrackingDialog = true 
                var lang = localStorage.getItem('lang')
                lang = ((lang == null || lang == undefined) ? 'en' : lang);
                window.setVisualTrackingData(this.selectedItem.item.documentId);
                this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                window.open(this.trackingFrameSrc, "_blank");
            } 
        },
        openSigningHistory() {
            this.selectedDocumentId = this.selectedItem.item.documentId
            this.signingHistoryDialog = true
        },
         notifyEmailCorrespondence(value,isTaskReminder) {
            //console.log("List_notifyEmailCorrespondence")
            //console.log(this.selectedItem.item);

            this.notifySubject = "Correspondence subject: " + this.selectedItem.item.subject;
            this.emailCC = this.selectedItem.item.sentToManagerEmail;
            this.toEmail = this.selectedItem.item.sentToEmail;
            this.notifyEmailDialog = value;
		    this.isMOM=isTaskReminder;
           						  
        },

       
        printCorrespondence(value) {
            this.withAttachments = value;
            var methodUrl = 'Document/Download?documentId=' + this.selectedItem.item.documentId
            if (this.withAttachments)
                methodUrl = 'Document/DownloadWithAttachments?documentId=' + this.selectedItem.item.documentId

            utils.DownloadFile(constants.baseApiUrl + methodUrl, this.selectedItem.item.subject + '-' + this.selectedItem.item.referenceNumber + '.pdf')
        },
        printCorrespondences(value)
        {
            var documentIds = this.selected.map(item => item.documentId).toString()

            this.withAttachments = value;
            var methodUrl = 'Document/DownloadMulti?documentIds=' + documentIds
            if (this.withAttachments)
                methodUrl = 'Document/DownloadMultiWithAttachments?documentIds=' + documentIds
            
            utils.DownloadFile(constants.baseApiUrl + methodUrl, 'print.pdf')
        },
        Dismiss() {
            window.showInformation('Confirmation', window.translate("res_Msgs_TransferDismissConfirmation"),
                () => {
                    axios.get(constants.baseApiUrl + 'Transfer/DismissTransfer?transferId=' + this.selectedItem.item.transferId)
                        .then(res => {
                            if (res.data != null && res.data > 0) {
                                window.showAlert('res_Msgs_TransferDismiss', 'success')
                                this.refreshPage();
                            }
                        })
                        .catch(err => console.warn(err))
                });
        },
        CreateOutgoing() {
            this.messagesUtil.dispatchEvent({ key: "createOutgoingOnIncoming", documentId: this.selectedItem.item.documentId });
        },
        sendCorrespondence(value) {
            this.withAttachments = value;
            this.selectedDocumentId = this.selectedItem.item.documentId;
            this.dispatchFormDialog = true;
            this.transferId = this.selectedItem.item.transferId; 
        },
        dispatchCorrespondence() {
            this.selectedDocumentId = this.selectedItem.item.documentId
            this.dispatchCorrespondenceFormDialog = true
        },
        asyncFindSender(query) {
            this.loading = true
            utils.defaultGet(
                'StructureUser/search?showUsers=false&showInternalStructures=true&showExternalStructures=true&search=' + query,
                (res) => { this.sender_items = res.data; this.loading = false; },
                () => { this.loading = false; }, true);
        },
        clearFilters() {
            this.clearFiltersWithoutinitPage()
            this.initPage(0)
        },
        clearFiltersWithoutinitPage() {
            this.filter_reference_number = ''
            this.filter_created_date = ''
            this.filter_subject = ''
            this.filter_due_date = ''
            this.filter_sender = null
            this.filter_purpose = null
            this.filter_category = null
            this.shown = false
            this.filter_Unopened_Document = false
            this.filter_Overdue_Document = false
        },
        applyFilters() {
            this.selected = []
           // this.selectedItem = null
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.shown = false
            this.initPage(0)
        },
        isCced() {
            return this.selectedItem.item.purposeId == 4 || this.selectedItem.item.cCed == true
        },
        isSendBackEnabled() {
            // 8: For Signature, 15: For Endorsement
            return (this.nodeId === 2 && this.selectedItem.item.cCed == false)
        },
        isRejectEnabled() {
            // 8: For Signature, 15: For Endorsement
            return (this.nodeId === 2 && this.isCced() == false && this.selectedItem.item.categoryId != 1 && (this.selectedItem.item.purposeId === 8 || this.selectedItem.item.purposeId === 3))
        },
        recall() {
            window.showInformation(window.translate("res_Msgs_Confirmation"), window.translate("res_Msgs_TransferRecallConfirmation"),
                () => {
                    utils.defaultPost('Document/Recall?transferId=' + this.selectedItem.item.transferId, null,
                        (res) => {
                            if (res.data.item1 == true) {
                                window.showAlert('res_Msgs_TransferRecalled', 'success')
                                this.refreshPage()
                            }
                            else {
                                window.showAlert('res_Msgs_TransferRecallFailed', 'warning')
                            }
                        }, this.handleError, true);
                },
                () => { })
        },
        openDeliveryNote() {
                if(!(this.selectedItem.item.statusId == 3 || this.selectedItem.item.statusId == 5))
                {
                    window.showAlert(this.$t('res_Msgs_TheCorrespondenceMustBeSignedFirst'), 'warning')
                    return;
                }
            this.documentId = this.selectedItem.item.documentId;

            axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' + this.documentId)
                .then((res) => {
                    if (res.data == true) {
                        window.showAlert('res_Msgs_DeliveryNoteCreationValidation', 'warning')
                    }
                    else {
                        this.referenceNumber = this.selectedItem.item.referenceNumber;
                        this.deliveryNoteDialog = true;
                    }
                })
                .catch((err) => { console.log(err); window.hideLoading(); })
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        closeDeliveryNoteDialog() {
            this.deliveryNoteDialog = false
            this.refreshPage()
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
        },
        getRowClass(item) {
            var retVal = ''
            if (item.openedDate || item.closedDate || item.openedForPreview || this.nodeId != 2)
                retVal = ''
            else
                retVal = 'tr-bold'

            if (this.selectedItem != null && this.selectedItem.item != null && item == this.selectedItem.item) {
                this.selectedItem.value = true
                retVal += 'custom-class'
            }

            return retVal
        },
        showTooltip(text) {
            const element = this.$refs.ellipsisElements;
            if (element) {
                element.textContent = text;
                return element.offsetHeight < element.scrollHeight;
            }

            return false;
        },
        showTooltips() {
            var elements = document.getElementsByClassName('td-text-limit');
            for (var i = 0; i < elements.length;) {
                var element1 = elements[i];
                var element2 = elements[i + 1];
                var showTooltip = element1.offsetHeight < element1.scrollHeight;
                if (element1.id.lastIndexOf('ellipsisElements') != -1 && element2.id.lastIndexOf('ellipsisElements') != -1) {
                    if (showTooltip) {
                        element1.style.display = 'none';
                        element2.style.display = '-webkit-box';
                    }
                    else {
                        element1.style.display = '-webkit-box';
                        element2.style.display = 'none';
                    }
                }

                i = i + 2;
            }
        },
        updateSortBy(column) {
            this.sortBy = column;
            this.sortDesc = false;
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
            this.getItemsForSelectedInbox(true);
        },
        updateSortDesc(desc) {
            this.sortDesc = desc;
            this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
          //  this.selectedItem = null

            this.getItemsForSelectedInbox(true)
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getItemsForSelectedInbox(false);
        },
        openCompleteDocumentDialog() {
            this.completeDocument_noteText = ''
            this.completeDocumentDialog = true
        },
        completeDocument() {
            if (this.completeDocument_noteText.trim().length == 0) {
                window.showAlert('res_Msgs_FillRequired', 'warning')
                return
            }
            let transferIds = this.selected.map(item => item.transferId).join(',') || this.selectedItem.item.transferId;
            let documentIds = this.selected.map(item => item.documentId).join(',') || this.selectedItem.item.documentId;
  
            window.showLoading()
          //  axios.get(constants.baseApiUrl + 'Document/CheckUserHavePermissionOnDocument?documentId=' + this.selectedItem.item.documentId)
          //      .then(res => {
          //          if (res.data == 1) {
           //             var body = { documentId: this.selectedItem.item.documentId, transferId: this.selectedItem.item.transferId, instructions: this.completeDocument_noteText };
           axios.get(constants.baseApiUrl + 'Document/CheckCanCompleteDocument?documentId=' + documentIds + '&transferId=' + transferIds + '&needClassification=' + false)
                .then(res => {
                    if (res.data == 1 || res.data == 'True') {
                        var body = { 
                            documentId: documentIds, 
                            transferId: transferIds, 
                            instructions: this.completeDocument_noteText, 
                            classificationPlanId: this.showClassificationField == true? this.classificationPlanId : null,
                            delegationId: this.selected_node.delegationId
                        };

                        axios.post(constants.baseApiUrl + 'Document/CompleteDocument', body, { headers: constants.headers })
                            .then(() => {
                                window.showAlert('res_Msgs_DocumentCompletedSuccess', 'success')
                                this.completeDocumentDialog = false;
                                this.refreshPage()
                            })
                            .catch(error => console.log(error))
                            .finally(() => window.hideLoading())
                    }
                    else {
                        window.hideLoading()
                        window.showAlert('res_Msgs_DocumentNotArchived', 'warning')
                    }
                })
                .catch(error => {
                    console.log(error)
                    window.hideLoading()
                    this.completeDocumentDialog = false
                })
        },
        SaveForLater() {
            if (this.hideToDate == '') {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                return
            }
            window.showLoading();
            axios.get(constants.baseApiUrl + 'Document/SaveForLater?transferId=' + this.selectedItem.item.transferId + '&toDate=' + this.hideToDate)
                .then((res) => {
                    if (res.data == false) {
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    this.hideCorrespondenceDialog = false;
                    this.hideToDate = '';
                    this.hideToDateMenu = false;
                    this.refreshPage();
                })
                .catch((err) => { console.log(err); })
                .finally(() => { window.hideLoading(); })
        },
        returnToInbox() {
            window.showLoading();
            axios.get(constants.baseApiUrl + 'Document/ReturnToInbox?transferId=' + this.selectedItem.item.transferId)
                .then((res) => {
                    if (res.data == false) {
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    this.refreshPage();
                })
                .catch((err) => { console.log(err); })
                .finally(() => { window.hideLoading(); })
        },
        ReminderByEmail() {
            if (this.reminderToDate == '') {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
                return
            }
            window.showLoading();
            axios.post(constants.baseApiUrl + 'Transfer/ReminderByEmail?transferId=' + this.selectedItem.item.transferId + '&toDate=' + this.reminderToDate + '&toEmails=' + this.fromEmail)
                .then((res) => {
                    if (res.data == false) {
                        window.showAlert(this.$t('res_Msgs_TransferNotFound'), "warning")
                    }
                    window.showAlert(this.$t('res_Msgs_Reminder'), 'success')
                    this.reminderEmailDialog = false;
                    this.reminderToDate = '';
                    this.hideToDateMenu = false;
                    this.refreshPage();
                })
                .catch((err) => { console.log(err); })
                .finally(()=>{ window.hideLoading(); })
            },
            resetDocument() {
                window.showLoading();
                axios.patch(constants.baseApiUrl + 'Document/ResetDocument?documentId=' + this.selectedItem.item.documentId, null)
                    .then((res) => {
                        if (!utils.CheckIfNullOrEmpty(res))
                            window.showAlert('res_Msgs_SuccessTheDocumentHasBeenReset', 'success');

                        this.refreshPageGrid()
                        this.closePreview()
                    })
                    .catch(error => console.log(error))
                    .finally(() => { window.hideLoading(); })
            },
            getCategoryTitle(categoryId)
            {
                var category = this.category_items.find(x => x.id == categoryId)
                if (category != null && category != undefined)
                    return (this.isLanguageEn ? category.name : category.nameAr)
                else
                    return ''
            },          
            shouldShowExpand(){
                return (this.nodeId=="6" || this.nodeId=="2") && constants.expandSentInboxRowFeature == "true";
            },
            filterByPurposeOld(purposeName){
                if (purposeName != null){
                    //console.log("logging action types")
                    //console.log(purposeName)
                    //console.log(this.action_types)
                    const purposeObject = this.action_types.find(at => at.name == purposeName);
                    if (purposeObject != null){
                        console.log("applying filter")
                        this.filter_purpose = purposeObject;
                        this.applyFilters();
                    }
                }
            },
            filterByPurpose(purposeName) {
                if (purposeName) {
                    // console.log("logging action types")
                    // console.log(purposeName)
                    // console.log(this.action_types)
                    //console.log("filtering by purpose"+ purposeName)
                    //console.log(this.action_types);
                    if (Array.isArray(this.action_types) && this.action_types.length) {
                        const purposeObject = this.action_types.find(at => at.name === purposeName);
                        console.log("applying filter0")
                        if (purposeObject) {
                            console.log("applying filter1")
                            this.filter_purpose = purposeObject;
                            this.applyFilters();
                        }
                    }
                }
            },
            handleToolBarWindowResize(fireResize)
            {
                this.toolbarButtons = [];
                this.moreActionButtons = [];

                var allBtns = [
                    { btnClass: 'light-blue',       btnClick: () => this.deleteDraftDocument(), btnText: 'res_ButtonText_Delete', btnIcon: undefined, btnPermission: 'DeleteDraft' },
                    { btnClass: 'light-blue',       btnClick: () => this.recall(), btnText: 'res_MenuItems_Recall', btnIcon: undefined, btnPermission: 'Recall' },
                    { btnClass: 'light-success',    btnClick: () => this.signDocument(), btnText: 'res_ButtonText_Sign', btnIcon: undefined, btnPermission: 'Sign' },
                    { btnClass: 'light-success',    btnClick: () => this.OpenTransferForm('Sign'), btnText: 'res_ButtonText_SignAndSend', btnIcon: undefined, btnPermission: 'SignAndSend' },
                    { btnClass: 'danger',           btnClick: () => this.OpenTransferForm('Rejected'), btnText: 'res_ButtonText_Reject', btnIcon: 'mdi-close-circle', btnPermission: 'Reject' },
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('Forward'), btnText: 'res_MenuItems_Forward', btnIcon: undefined, btnPermission: 'Forward' },
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('ForwardCc'), btnText: 'res_MenuItems_ForwardCC', btnIcon: undefined, btnPermission: 'ForwardCc' },
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('SendCC'), btnText: 'res_MenuItems_SendCC', btnIcon: undefined, btnPermission: 'SendCC' },
                    { btnClass: 'light-blue',       btnClick: () => this.notifyEmailCorrespondence(true,false), btnText: 'res_MenuItems_NotifyEmail', btnIcon: undefined, btnPermission: 'NotifyEmail'},
                    { btnClass: 'light-blue',       btnClick: () => this.OpenTransferForm('Endorse'), btnText: 'res_MenuItems_Endorse', btnIcon: undefined, btnPermission: 'Endorse' },
                    { btnClass: 'light-blue',       btnClick: () => this.openCompleteDocumentDialog(), btnText: 'res_ButtonText_Archive', btnIcon: undefined, btnPermission: 'Archive' },
                    { btnClass: 'light-blue',       btnClick: () => this.Dismiss(), btnText: 'res_ButtonText_isDismiss', btnIcon: undefined, btnPermission: 'Dismiss' },
                    { btnClass: 'light-blue',       btnClick: () => this.DismissCced(), btnText: 'res_Label_CcedDismiss', btnIcon: undefined, btnPermission: 'DismissCced' },
                    { btnClass: 'light-blue',       btnClick: () => this.returnToInbox(), btnText: 'res_ButtonText_ReturnToInbox', btnIcon: undefined, btnPermission: 'ReturnToInbox' },
                ]

                //var alwaysMoreAction = ['', '', '', '', '', '', '', ''];

                var context = this;

                function onResize(){
                    context.toolbarButtons = [];
                    context.moreActionButtons = [];

                    var rowContainer = document.getElementById("rowContainer");
                    if (rowContainer) {
                        var width = rowContainer.clientWidth - (150 + 150 + 40 + 20) //static buttons width

                        for(var i=0; i < allBtns.length; i++){
                            if(width > 130){
                                if(utils.ActionsPermission(`${allBtns[i].btnPermission}`, context.selectedItem.item, context.selectedItem.item.transferId, context.selected_node.delegationId, context.nodeId, context.canSignDocument)){
                                    context.toolbarButtons.push(allBtns[i]);
                                    width -= 130;
                                }
                            }else{
                                if(utils.ActionsPermission(`${allBtns[i].btnPermission}`, context.selectedItem.item, context.selectedItem.item.transferId, context.selected_node.delegationId, context.nodeId, context.canSignDocument)){
                                    context.moreActionButtons.push(allBtns[i]);
                                }
                            }
                        }

                    }
                }

                window.onresize = ()=>{
                    onResize();
                }
                if(fireResize){
                    this.$nextTick(() => {
                        onResize();
                    });
                }
            }
        },
        watch : 
        {
            nodeId: function() 
            {
                this.clearFiltersWithoutinitPage()
                this.initPage(0)
                this.initPageOnNodeIdChange()

                this.selected_index = 0
                this.selected_node = this.inboxes[0]
                this.selected = []
                this.selectedItem = {item:{isEsealEnabled:false,isUAEPassEnabled:false},value:false}
                this.action_types = [...this.allTransferPurposes]
                this.category_items = [...this.allDocumentCategories]
                //console.log('changed1 '+this.$route.query.purposeFilter);
                // this.$nextTick(() => {
                //     this.filterByPurpose(this.$route.query?.purposeFilter);
                // });
            },
            '$route.query.purposeFilter': {
                handler: function(search){
                    //console.log('changed '+ search);
                    // this.$nextTick(() => {
                    //     this.filterByPurpose(this.$route.query?.purposeFilter);
                    // });
                },
                deep: true,
                immediate: true
            },
            correspondences: function() {
                this.$nextTick(() => {
                    this.filterByPurpose(this.$route.query?.purposeFilter);
                });
            }
        },
        computed: {

            ...mapGetters(['allTransferPurposes', 'allDocumentCategories']), // Spread the existing mapGetters
             filteredHeaders() {
               //console.log( "this.nodeId:"+this.nodeId)
          
            if (this.nodeId == 6) {
                return  this.expanded_headers_sent; 
                } else {
                    return this.expanded_headers; 
                }
            },
            enableSingleSelect()
            {
                return !((this.nodeId === 10 || this.nodeId === 2 || this.nodeId === 1) && window.selectMultiDocument === true);
            }
            // groupedCorrespondences() {
            //     const grouped = [];
            //     const map = new Map();

            //     this.correspondences.forEach((item) => {
            //     if (!map.has(item.documentId)) {
            //         map.set(item.documentId, { ...item, grouped: [] });
            //         grouped.push(map.get(item.documentId));
            //     }
            //     map.get(item.documentId).grouped.push(item);
            //     });

            //     return grouped;
            // },
        },

        //computed: mapGetters(['allTransferPurposes', 'allDocumentCategories']),

}
</script>

<style>
.expanded-item-container {
    margin: 0;
    padding: 0;
}

.expanded-item-table {
    width: 100%;
    margin: 0;
    padding: 0;
}

/* Target the td that contains the expanded content */
.v-data-table__expanded td {
    padding: 0 !important;
}

.v-popper--theme-tooltip {
    max-width: 400px !important;
}

.tr-bold td {
    font-weight: 600 !important;
}

.show-tooltip {
    position: relative;
    cursor: pointer;
}

.show-tooltip::before {
    content: attr(title);
    position: absolute;
    top: -20px;
    left: 0;
    background-color: #000;
    color: #fff;
    padding: 5px;
    border-radius: 3px;
    opacity: 0.8;
    /* Additional tooltip styling */
}

.inbox_tab_name {
    text-transform: none !important;
}

tr.custom-class {
    background: #F0F8FF;
}

tr.custom-class .v-icon.mdi-checkbox-blank-outline:before {
    content: "";
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 4px;
    background-color: #205cdf;
    background-image: url(../assets/images/icons/tick.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px;
}

#viewerFrame {
    height: calc(100% - 39px);
}

.transparentBg {
    background: transparent !important;
}

.custom-button {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
}

.DocumentsList tr td .subjectCell {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
}

#ListCorrespondancesTable table thead th.text-start  {
    background: var(--table-header-color);
    padding-left: 8px !important;
    padding-right: 8px !important;
}

</style>